  document.addEventListener('DOMContentLoaded', function() {
    function zinusScheduleIdle(run) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () { run(); }, { timeout: 2200 });
      } else {
        window.setTimeout(run, 150);
      }
    }

    let dataColors = [];
    let colorsJson = window.theme.assets.swatches;
    let variantID = 0;
    const enableMulberryUpsell = document.querySelector('custom-product')?.dataset.rebuyMulberryUpsell === 'true';
    const rebuyUpsellProperties = {
      attribution: 'Rebuy Product',
      source: 'Rebuy',
      widgetId: '166634'
    };
    fetch(colorsJson)
      .then(response => {
        // Check if the response is ok (status code in the range 200-299)
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        // Parse the JSON data
        return response.json();
      })
      .then(data => {
        // Use the retrieved data
        // Function to get hex value by color name
        // Example usage
        dataColors = data.colors;
      })
      .catch(error => {
        // Handle any errors
        console.error('There was a problem with the fetch operation:', error?.message);
      });

    zinusScheduleIdle(function initZinusSecondaryDialogs() {
      const hybridsBtns = document.querySelectorAll(".hybrid-btn");
      const hybridsCancelButton = document.getElementById("hybridsCancelBtn");
      const hybridsDialog = document.getElementById("hybridsDialog");

      if (hybridsDialog) {
        if (hybridsBtns?.length) {
          hybridsBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              hybridsDialog.showModal();
            });
          });
        }

        hybridsCancelButton?.addEventListener("click", () => {
          hybridsDialog.close();
        });

        hybridsDialog.addEventListener("click", (event) => {
          if (event.target === hybridsDialog) {
            hybridsDialog.close();
          }
        });

        hybridsCancelButton?.addEventListener("keydown", (e) => {
          if (e.code === "Space" || e.key === "Enter" || e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            hybridsDialog.close();
            hybridsDialog.removeAttribute('aria-modal');
          }
        });
      }

      const sizeGuideBtn = document.querySelectorAll(".size-guide-btn");
      const cancelButton = document.getElementById("sizeGuideCancelBtn");
      const Guidedialog = document.getElementById("sizeGuideDialog");

      if (Guidedialog) {
        if (sizeGuideBtn?.length) {
          sizeGuideBtn.forEach((btn) => {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              Guidedialog.showModal();
            });
          });
        }

        cancelButton?.addEventListener("click", () => {
          Guidedialog.close();
        });

        cancelButton?.addEventListener("keydown", (e) => {
          if (e.code === "Space" || e.key === "Enter" || e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            Guidedialog.close();
          }
        });

        Guidedialog.addEventListener("click", (event) => {
          if (event.target === Guidedialog) {
            Guidedialog.close();
          }
        });
      }
    });

    
    // PRODUCT PAGE PRICING - MATERIAL RADIO BUTTONS
    const memoryFoam = document.querySelector('.zin-memory-foam');
    const hybrid = document.querySelector('.zin-hybrid');

    let tablist;
    let tablists = document.querySelectorAll('.pdp-tabs');

    tablists.forEach((tablist) => {
      let tabs = tablist.querySelectorAll('.pdp-tablinks:not([disabled="true"])');
      let tabpanels = tablist.querySelectorAll('.pdp-tabcontent');

      tablist.addEventListener('keydown', function(e) {
        switch(e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();   // prevent page scroll
            selectPreviousTab(tablist, tabpanels, tabs);
            break;
            
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();  // prevent page scroll
            selectNextTab(tablist, tabpanels, tabs);
            break;
            
          case 'Home':
            e.preventDefault();  // prevent page scroll
            selectFirstTab(tablist, tabpanels, tabs);
            break;
            
          case 'End':
            e.preventDefault();  // prevent page scroll
            selectLastTab(tablist, tabpanels, tabs);
            break;
        }
      });
      // Activate tabs when they are clicked (also handles Enter and Space keys)
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          const nextTabIndex = Array.prototype.slice.call(tabs).indexOf(e.target);
          selectTab(nextTabIndex, tabpanels, tabs);
        });
      });
    });
    

    function selectPreviousTab(tablist, tabpanels, tabs) {
      var activeTab = tablist.querySelector('.pdp-tablinks[aria-selected="true"]');
      var activeTabIndex = Array.prototype.slice.call(tabs).indexOf(activeTab);
      
      // Select the previous tab, wrapping to last tab if needed
      if(activeTabIndex > 0) {
        selectTab(activeTabIndex - 1, tabpanels, tabs);
      } else {
        selectTab(tabs.length - 1, tabpanels, tabs);
      }
    }

    function selectNextTab(tablist, tabpanels, tabs) {
      var activeTab = tablist.querySelector('.pdp-tablinks[aria-selected="true"]');
      var activeTabIndex = Array.prototype.slice.call(tabs).indexOf(activeTab);
      
      // Select the previous tab, wrapping to first tab if needed
      if(activeTabIndex < tabs.length - 1) {
        selectTab(activeTabIndex + 1, tabpanels, tabs);
      } else {
        selectTab(0, tabpanels, tabs);
      }
    }

    function selectFirstTab(tablist, tabpanels, tabs) {
      selectTab(0, tabpanels, tabs);
    }

    function selectLastTab(tablist, tabpanels, tabs) {
      selectTab(tabs.length - 1, tabpanels, tabs);
    }

    function selectTab(index, tabpanels, tabs) {
      // Deactivate all tabs
      tabs.forEach(function(tab) {
        tab.setAttribute('aria-selected', false);
        tab.setAttribute('tabindex', -1);
      });
      
      // Activate only the requested tab, and set focus to it
      tabs[index].setAttribute('aria-selected', true);
      tabs[index].setAttribute('tabindex', 0);
      tabs[index].focus();   
      // Hide all tabpanels
      tabpanels.forEach(function(tabpanel) {
        tabpanel.classList.remove('is-visible');
      });
      
      // Show only the tabpanel for the requested tab
      var nextTabpanel = tabpanels[index];
      nextTabpanel.classList.add('is-visible');
    }
    
    function isBalancedComfortProduct() {
      const currentProductId = document.querySelector('[data-current-id]')?.getAttribute('data-current-id');
      const currentRelatedTitle = currentProductId
        ? document.querySelector(`.zinus_product[data-product-id="${currentProductId}"]`)?.dataset.productTitle
        : '';
      const handle = document.querySelector('[data-product-handle]')?.dataset.productHandle || '';
      const haystack = `${currentRelatedTitle || ''} ${handle}`;
      return /balanced comfort|balanced-comfort/i.test(haystack);
    }

    const LEGACY_SUCCESSOR_HANDLES = {
      'original-green-tea': 'balanced-comfort-core-memory-foam-mattress',
      'cooling-green-tea': 'balanced-comfort-signature-memory-foam-mattress',
      'ultra-green-tea': 'balanced-comfort-luxe-memory-foam-mattress',
      'original-hybrid-mattress': 'balanced-comfort-core-hybrid-mattress',
      'cooling-hybrid-mattress': 'balanced-comfort-signature-hybrid-mattress',
      'ultra-hybrid-mattress': 'balanced-comfort-luxe-hybrid-mattress'
    };

    const LEGACY_UPGRADE_HANDLES = {
      'original|memory foam': 'original-green-tea-memory-foam-mattress',
      'original|hybrid': 'original-green-tea-hybrid-mattress',
      'cooling|hybrid': 'cooling-green-tea-gel-memory-foam-hybrid-mattress',
      'ultra cooling|memory foam': 'ultra-cooling-gel-memory-foam-mattress'
    };

    const UNPUBLISHED_COMBO_SUCCESSOR_HANDLES = {
      'original|memory foam': 'balanced-comfort-core-memory-foam-mattress',
      'original|hybrid': 'balanced-comfort-core-hybrid-mattress',
      'cooling|memory foam': 'balanced-comfort-signature-memory-foam-mattress',
      'cooling|hybrid': 'balanced-comfort-signature-hybrid-mattress',
      'ultra cooling|memory foam': 'balanced-comfort-luxe-memory-foam-mattress',
      'ultra cooling|hybrid': 'balanced-comfort-luxe-hybrid-mattress'
    };

    let unpublishedComboSelected = false;
    let unpublishedComboSuccessorHandle = '';
    let cachedUpsellProduct = null;
    let upsellRequestToken = 0;
    let pendingUpsellPromise = null;
    let pendingUpsellCount = 0;
    let resolvePendingUpsell = null;
    let allowOriginAtcClick = false;
    const upsellModalBtn = document.querySelectorAll(".upsell-popup__button");
    const upsellModal = document.querySelector(".upsell-popup__wrapper");
    const upsellCancelBtn = document.querySelector("#closeUpsellModalBtn");
    let upsellModalTrigger = null;

    function hasLegacySuccessorPdp() {
      return Boolean(document.querySelector('.zinus-mattress-pdp.has-legacy-successor'));
    }

    function resolveSuccessorHandle(currentHandle, tag) {
      // Origin Green Tea / Hybrid only. Balanced Comfort keeps Notify Me.
      if (isBalancedComfortProduct() || !hasLegacySuccessorPdp()) return '';
      let handle = LEGACY_SUCCESSOR_HANDLES[tag];
      if (!handle) {
        handle = /hybrid/i.test(currentHandle)
          ? 'balanced-comfort-signature-hybrid-mattress'
          : 'balanced-comfort-signature-memory-foam-mattress';
      }
      if (!handle || handle === currentHandle) return '';
      return handle;
    }

    function toggleSoldOutMessage(isSoldOut) {
      const messages = document.querySelectorAll('.legacy-soldout-message');
      if (!messages.length) return;
      const show = Boolean(isSoldOut) && hasLegacySuccessorPdp();
      messages.forEach((message) => {
        message.classList.toggle('hidden', !show);
        message.classList.toggle('is-visible', show);
      });
      if (!show) return;

      const currentHandle = document.querySelector('[data-product-handle]')?.dataset.productHandle || '';
      const tag = (document.querySelector('.mattress-product-title')?.value || '').trim();
      const handle = unpublishedComboSuccessorHandle || resolveSuccessorHandle(currentHandle, tag);
      const links = document.querySelectorAll('.legacy-soldout-message a');
      if (!links.length || !handle) return;

      let size = getSelectedMattressSizeLabel();
      if (!isMattressBedSizeLabel(size)) {
        size = Array.from(document.querySelectorAll('.select-popout__item--current span'))
          .map((el) => (el.textContent || '').trim())
          .find(isMattressBedSizeLabel) || '';
      }
      const baseHref = '/products/' + handle;
      links.forEach((link) => {
        link.href = baseHref;
      });
      fetch('/products/' + handle + '.js')
        .then((res) => (res.ok ? res.json() : null))
        .then((product) => {
          if (!product || !size || !Array.isArray(product.variants)) return;
          const sizeLower = String(size).trim().toLowerCase();
          const match = product.variants.find((v) => {
            const option1 = String(v.option1 || '').trim().toLowerCase();
            const title = String(v.title || '').trim().toLowerCase();
            return option1 === sizeLower || title === sizeLower || title.split(' / ')[0] === sizeLower;
          });
          if (match && match.id) {
            const variantHref = '/products/' + handle + '?variant=' + match.id;
            links.forEach((link) => {
              link.href = variantHref;
            });
          }
        })
        .catch(() => {});
    }

    function initVariant() {
      const titleEl = document.querySelector('.mattress-product-title');
      const mattressProductTitle = (titleEl?.value || titleEl?.textContent || '').trim();

      // ---------- helpers ----------
      function setChecked(selector) {
        const el = document.querySelector(selector);
        if (!el) return;

        setTimeout(() => {
          el.checked = true;
        }, 50);

        // Important: notify any theme logic listening for changes
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }

      function addHidden(selector) {
        document.querySelector(selector)?.classList.add('hidden');
        if(document.querySelectorAll('.custom-select-popout__list__scroll .custom-select-popout__item').length){
          document.querySelectorAll('.custom-select-popout__list__scroll .custom-select-popout__item').forEach((item) => {
            item.classList.remove('select-popout__item--current');
          })
        }
      }

      function removeOpacity(selector) {
        document.querySelector(selector)?.classList.remove('opacity');
      }

      function clearSelectionsAndResetUI() {
        // Clear checked states (critical for browser Back / bfcache)
        document.querySelectorAll(
          '#zinusOriginalRadio input, ' +
          '#zinusPremierRadio--2 input, ' +
          '#zinusPremierRadio--3 input, ' +
          '#materialHybrid input, ' +
          '#materialMemoryFoam input'
        ).forEach((i) => {
          i.checked = false;
        });

        // Reset visibility & opacity so each case starts clean
        document.querySelectorAll(
          '#zinusOriginalRadio, #zinusPremierRadio--2, #zinusPremierRadio--3'
        ).forEach((el) => {
          el.classList.remove('hidden');
          el.classList.remove('opacity');
        });

        document.querySelector('.pdp-variant-1-text')?.classList.remove('hidden');
      }

      if (!mattressProductTitle) return;

      // Reset first so restored DOM state doesn't override logic
      clearSelectionsAndResetUI();

      // Balanced Comfort reuses legacy tags (original-green-tea, etc.). Detect from the
      // current product only so classic Green Tea PDPs keep the original switch logic.
      // Visibility mirrors original: show the related pair only (not all three tiers).
      if (isBalancedComfortProduct()) {
        const currentTitle = (
          document.querySelector(`.zinus_product[data-product-id="${document.querySelector('[data-current-id]')?.getAttribute('data-current-id')}"]`)?.dataset.productTitle
          || document.querySelector('[data-product-handle]')?.dataset.productHandle
          || ''
        );
        const isHybrid = /hybrid/i.test(currentTitle);
        const isSignature = /signature/i.test(currentTitle);
        const isLuxe = /luxe/i.test(currentTitle);

        if (isHybrid) {
          setChecked('#materialHybrid input');
          if (document.querySelector('#size-hybrid')) {
            document.querySelector('#size-hybrid').classList.add('select-popout__item--current');
            document.querySelector('.material_choose-wrapper .select-popout__value').textContent = 'Hybrid';
          }
        } else {
          setChecked('#materialMemoryFoam input');
          if (document.querySelector('#size-memory-foam')) {
            document.querySelector('#size-memory-foam').classList.add('select-popout__item--current');
            document.querySelector('.material_choose-wrapper .select-popout__value').textContent = 'Memory Foam';
          }
        }

        if (isLuxe) {
          // Same as ultra-*: hide upgrade picker on the top tier.
          setChecked('#zinusPremierRadio--3 input');
          addHidden('.pdp-variant-1-text');
          addHidden('#zinusOriginalRadio');
          addHidden('#zinusPremierRadio--2');
          addHidden('#zinusPremierRadio--3');
        } else if (isSignature) {
          // Same as cooling-*: Signature + Luxe only.
          setChecked('#zinusPremierRadio--2 input');
          addHidden('#zinusOriginalRadio');
          removeOpacity('#zinusPremierRadio--2');
          removeOpacity('#zinusPremierRadio--3');
          if (document.querySelector('.upgrade_product_title')) {
            document.querySelector('.upgrade_product_title').textContent = isHybrid
              ? 'Upgrade to Balanced Comfort Luxe Hybrid'
              : 'Upgrade to Balanced Comfort Luxe';
          }
        } else {
          // Same as original-*: Core + Signature only.
          setChecked('#zinusOriginalRadio input');
          addHidden('#zinusPremierRadio--3');
          removeOpacity('#zinusOriginalRadio');
          removeOpacity('#zinusPremierRadio--2');
          if (document.querySelector('.upgrade_product_title')) {
            document.querySelector('.upgrade_product_title').textContent = isHybrid
              ? 'Upgrade to Balanced Comfort Signature Hybrid'
              : 'Upgrade to Balanced Comfort Signature';
          }
        }

        return;
      }

      // ---------- variant logic ----------
      switch (mattressProductTitle) {
        case 'cooling-hybrid-mattress':
          setChecked('#zinusPremierRadio--2 input');
          setChecked('#materialHybrid input');
          addHidden('#zinusOriginalRadio');
          removeOpacity('#zinusPremierRadio--3');
          removeOpacity('#zinusPremierRadio--2');
          if(document.querySelector('#size-hybrid')){
            document.querySelector('#size-hybrid').classList.add('select-popout__item--current');
            document.querySelector(".material_choose-wrapper .select-popout__value").textContent = 'Hybrid';
          }
          if (document.querySelector('.upgrade_product_title')) {
            document.querySelector('.upgrade_product_title').textContent = 'Upgrade to Ultra Cooling Green Tea Hybrid';
          }
          break;

        case 'original-hybrid-mattress':
          setChecked('#zinusOriginalRadio input');
          setChecked('#materialHybrid input');
          addHidden('#zinusPremierRadio--3');
          removeOpacity('#zinusOriginalRadio');
          removeOpacity('#zinusPremierRadio--2');
          if(document.querySelector('#size-hybrid')){
            document.querySelector('#size-hybrid').classList.add('select-popout__item--current');
            document.querySelector(".material_choose-wrapper .select-popout__value").textContent = 'Hybrid';
          }
          if (document.querySelector('.upgrade_product_title')) {
            document.querySelector('.upgrade_product_title').textContent = 'Upgrade to Cooling Green Tea Hybrid';
          }
          break;

        case 'ultra-hybrid-mattress':
          setChecked('#materialHybrid input');
          setChecked('#zinusPremierRadio--3 input');
          addHidden('.pdp-variant-1-text');
          addHidden('#zinusOriginalRadio');
          addHidden('#zinusPremierRadio--2');
          addHidden('#zinusPremierRadio--3');
          if(document.querySelector('#size-hybrid')){
            document.querySelector('#size-hybrid').classList.add('select-popout__item--current')
            document.querySelector(".material_choose-wrapper .select-popout__value").textContent = 'Hybrid';
          } 
          break;

        case 'original-green-tea':
          setChecked('#zinusOriginalRadio input');
          setChecked('#materialMemoryFoam input');
          addHidden('#zinusPremierRadio--3');
          removeOpacity('#zinusOriginalRadio');
          removeOpacity('#zinusPremierRadio--2');
          if(document.querySelector('#size-memory-foam')){
            document.querySelector(".material_choose-wrapper .select-popout__value").textContent = 'Memory Foam';
            document.querySelector('#size-memory-foam').classList.add('select-popout__item--current')
          }
            
          if (document.querySelector('.upgrade_product_title')) {
            document.querySelector('.upgrade_product_title').textContent = 'Upgrade to Cooling Green Tea';
          }
          break;

        case 'ultra-green-tea':
          addHidden('.pdp-variant-1-text');
          setChecked('#materialMemoryFoam input');
          setChecked('#zinusPremierRadio--3 input');
          addHidden('#zinusOriginalRadio');
          addHidden('#zinusPremierRadio--2');
          addHidden('#zinusPremierRadio--3');
          if(document.querySelector('#size-memory-foam')){
            document.querySelector(".material_choose-wrapper .select-popout__value").textContent = 'Memory Foam';
            document.querySelector('#size-memory-foam').classList.add('select-popout__item--current')
          }
          break;

        case 'cooling-green-tea':
          setChecked('#zinusPremierRadio--2 input');
          setChecked('#materialMemoryFoam input');
          addHidden('#zinusOriginalRadio');
          removeOpacity('#zinusPremierRadio--3');
          removeOpacity('#zinusPremierRadio--2');
          if(document.querySelector('#size-memory-foam')){
            document.querySelector('#size-memory-foam').classList.add('select-popout__item--current')
            document.querySelector(".material_choose-wrapper .select-popout__value").textContent = 'Memory Foam';
          }
          if (document.querySelector('.upgrade_product_title')) {
            document.querySelector('.upgrade_product_title').textContent = 'Upgrade to Ultra Cooling Green Tea';
          }
          break;

        default:
          break;
      }
    }

    function safeUrl(url) {
      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
          return '#';
        }
        return parsed.href;
      } catch {
        return '#';
      }
    }

    function safeImageUrl(url) {
      const safe = safeUrl(url);
      return safe === '#' ? '' : safe;
    }

    function safeColor(value) {
      if (typeof value !== 'string') return '';
      const trimmed = value.trim();

      const isHex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(trimmed);
      const isRgb = /^rgb(a)?\([0-9\s.,%]+\)$/.test(trimmed);

      return isHex || isRgb ? trimmed : '';
    }

    function escapeHtml(value = '') {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function getSelectedMattressSizeLabel() {
      // Prefer the size dropdown only. Quantity/other popouts also use --current
      // and can otherwise return "1".
      const fromSizeField = (
        document.querySelector('.zin-select__fieldset .select-popout__item--current .select-popout__option')?.dataset?.value ||
        document.querySelector('.zin-select__fieldset .select-popout__item--current span')?.textContent?.trim() ||
        ''
      ).trim();
      if (isMattressBedSizeLabel(fromSizeField)) return fromSizeField;

      const fromCurrent = (
        document.querySelector('.select-popout__list__scroll .select-popout__item--current .select-popout__option')?.dataset?.value ||
        document.querySelector('.select-popout__list__scroll .select-popout__item--current span')?.textContent?.trim() ||
        ''
      ).trim();
      if (isMattressBedSizeLabel(fromCurrent)) return fromCurrent;

      const fromSticky = (document.querySelector('.sticky-atc .select-popout__value')?.textContent || '').trim();
      if (isMattressBedSizeLabel(fromSticky)) return fromSticky;

      return fromSizeField || fromCurrent || fromSticky || '';
    }

    function isMattressBedSizeLabel(label) {
      var size = String(label || '').trim().toLowerCase();
      if (!size) return false;
      // Size dropdown only — ignore material options like "Memory Foam" / "Hybrid".
      return (
        size === 'twin' ||
        size === 'twin xl' ||
        size === 'full' ||
        size === 'queen' ||
        size === 'king' ||
        size === 'cal king' ||
        size === 'california king'
      );
    }

    const MATTRESS_SIZE_SOLD_OUT_LABEL = ', sold out';
    const MATTRESS_SIZE_OPTION_SELECTOR = '.zin-select__fieldset .select-popout__item[data-inventory-number], .sticky-atc .sticky-select-popout__item';

    function isMattressSizeOptionSoldOut(item) {
      if (!item) return false;
      if (item.classList.contains('sold-out') || item.classList.contains('unavailable')) return true;
      const value = item.querySelector('[data-popout-option]')?.getAttribute('data-value');
      if (!value || typeof CSS === 'undefined' || typeof CSS.escape !== 'function') return false;
      const mainOption = document.querySelector(
        `.zin-select__fieldset [data-popout-option][data-value="${CSS.escape(value)}"]`
      );
      const mainItem = mainOption?.closest('.select-popout__item');
      return !!(mainItem && (mainItem.classList.contains('sold-out') || mainItem.classList.contains('unavailable')));
    }

    function setMattressSizeOptionSoldOutA11y(item, isSoldOut) {
      const optionEl = item.querySelector('[data-popout-option]');
      if (!optionEl) return;

      if (isSoldOut) {
        item.setAttribute('aria-disabled', 'true');
        optionEl.setAttribute('aria-disabled', 'true');
        if (!optionEl.querySelector('[data-sold-out-label]')) {
          const sr = document.createElement('span');
          sr.className = 'visually-hidden';
          sr.setAttribute('data-sold-out-label', '');
          sr.textContent = MATTRESS_SIZE_SOLD_OUT_LABEL;
          optionEl.appendChild(sr);
        }
      } else {
        item.removeAttribute('aria-disabled');
        optionEl.removeAttribute('aria-disabled');
        optionEl.querySelector('[data-sold-out-label]')?.remove();
      }
    }

    function syncMattressSizeSoldOutA11y() {
      document.querySelectorAll(MATTRESS_SIZE_OPTION_SELECTOR).forEach((item) => {
        const optionValue = item.querySelector('[data-popout-option]')?.getAttribute('data-value');
        if (optionValue && !isMattressBedSizeLabel(optionValue)) return;
        setMattressSizeOptionSoldOutA11y(item, isMattressSizeOptionSoldOut(item));
      });
    }

    function observeMattressSizeSoldOutA11y() {
      const roots = document.querySelectorAll('.zin-select__fieldset .select-popout__list, .sticky-atc .select-popout__list');
      if (!roots.length) return;
      syncMattressSizeSoldOutA11y();
      const observer = new MutationObserver(syncMattressSizeSoldOutA11y);
      roots.forEach((root) => {
        observer.observe(root, { attributes: true, attributeFilter: ['class'], subtree: true });
      });
    }

    function findProtectorVariantForSize(variants, sizeLabel) {
      if (!Array.isArray(variants) || !sizeLabel) return null;
      var size = String(sizeLabel).trim();
      var sizeLower = size.toLowerCase();
      return (
        variants.find((v) => String(v.option1 || '').trim().toLowerCase() === sizeLower) ||
        variants.find((v) => String(v.title || '').trim().toLowerCase() === sizeLower) ||
        variants.find((v) => {
          var title = String(v.title || '');
          return title === size || title.indexOf(size + ' /') === 0 || title.indexOf(size + '/') === 0;
        }) ||
        variants.find((v) => Array.isArray(v.options) && v.options.some((o) => String(o).trim().toLowerCase() === sizeLower)) ||
        null
      );
    }

    function setCrossWidgetChecked(checked) {
      const checkbox = document.querySelector('.cross_widget #cross_widget');
      if (!checkbox) return;
      checkbox.checked = !!checked;
      document.querySelectorAll('.cross_widget .custom_checkbox').forEach((el) => {
        el.setAttribute('aria-checked', checked ? 'true' : 'false');
      });
    }

    function clearCrossWidgetFormInputs() {
      const crossProduct = document.querySelector('.cross_widget_product');
      const upsellIds = document.querySelector('.upsell-products__id-wrapper');
      if (crossProduct) crossProduct.innerHTML = '';
      if (upsellIds) upsellIds.innerHTML = '';
    }

    function writeCrossWidgetFormInputs(variantId) {
      if (!variantId) {
        clearCrossWidgetFormInputs();
        return;
      }
      const safeId = escapeHtml(String(variantId));
      const crossProduct = document.querySelector('.cross_widget_product');
      const upsellIds = document.querySelector('.upsell-products__id-wrapper');
      if (crossProduct) {
        crossProduct.innerHTML = `<input type="hidden" name="items[1][id]" value="${safeId}">`;
      }
      if (upsellIds) {
        upsellIds.innerHTML = `<input type="hidden" name="items[2][id]" value="${safeId}">`;
      }
    }

    /**
     * PDP mattress-protector block only (`.cross_widget`).
     * Queen (unavailable protector): hide block, uncheck, clear form ids.
     * Twin/Full/King when protector is in stock: show block again.
     * Does not touch ATC, Mulberry UI, sticky layout, Affirm, or Rebuy cart.
     */
    function syncMattressProtectorUpsell(sizeLabel) {
      const widget = document.querySelector('.cross_widget');
      if (!widget) return;

      const crossWidgetJson = widget.querySelector('[type="application/json"]');
      let variants = [];
      try {
        variants = crossWidgetJson ? JSON.parse(crossWidgetJson.textContent || '[]') : [];
      } catch (err) {
        variants = [];
      }

      const size = String(sizeLabel || getSelectedMattressSizeLabel() || '').trim();
      if (!isMattressBedSizeLabel(size)) return;

      const match = findProtectorVariantForSize(variants, size);
      const titleEl = widget.querySelector('.product_title');
      const priceEl = widget.querySelector('.variant_price');
      const wasHidden = widget.classList.contains('hidden');
      const sellable = !!(match && match.available !== false && match.available !== 'false');

      // No protector for this size, or protector OOS (Queen today) → hide block only.
      if (!match || !sellable) {
        if (titleEl) titleEl.dataset.productId = '';
        widget.classList.add('hidden');
        widget.setAttribute('aria-hidden', 'true');
        setCrossWidgetChecked(false);
        clearCrossWidgetFormInputs();
        return;
      }

      if (titleEl) titleEl.dataset.productId = String(match.id);
      if (priceEl) {
        const price = (Number(match.price) / 100).toFixed(2);
        priceEl.textContent = '(+$' + price + ')';
      }
      widget.classList.remove('hidden');
      widget.setAttribute('aria-hidden', 'false');

      // Coming back from Queen/OOS → show block again with automatic opt-in.
      if (wasHidden) setCrossWidgetChecked(true);

      const checkbox = document.querySelector('.cross_widget #cross_widget');
      if (checkbox?.checked) {
        writeCrossWidgetFormInputs(match.id);
      } else {
        clearCrossWidgetFormInputs();
      }
    }

    function createUpsellIcon() {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('width', '10');
      svg.setAttribute('height', '20');
      svg.setAttribute('viewBox', '0 0 10 10');
      svg.setAttribute('fill', 'none');

      const path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M3.71367 9.62V0.379999H6.29367V9.62H3.71367ZM0.253672 6.22V3.78H9.77367V6.22H0.253672Z');
      path.setAttribute('fill', '#60BF98');

      svg.appendChild(path);
      return svg;
    }

    function sanitizeHtmlToFragment(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString || '', 'text/html');

      // Remove dangerous elements completely
      doc.querySelectorAll('script, iframe, object, embed, link, meta, style, form').forEach((el) => {
        el.remove();
      });

      doc.querySelectorAll('*').forEach((el) => {
        [...el.attributes].forEach((attr) => {
          const name = attr.name.toLowerCase();
          const value = attr.value || '';

          // Remove inline event handlers
          if (name.startsWith('on')) {
            el.removeAttribute(attr.name);
            return;
          }

          // Sanitize URL-based attributes
          if (name === 'href' || name === 'src' || name === 'xlink:href') {
            const safe = safeUrl(value);
            if (safe === '#') {
              el.removeAttribute(attr.name);
            } else {
              el.setAttribute(attr.name, safe);
            }
            return;
          }

          // Sanitize style attributes to prevent CSS/script injection
          if (name === 'style') {
            el.removeAttribute('style');
            return;
          }
        });
      });

      const fragment = document.createDocumentFragment();
      [...doc.body.childNodes].forEach((node) => {
        fragment.appendChild(node.cloneNode(true));
      });

      return fragment;
    }

    function setSanitizedHtml(container, htmlString) {
      if (!container) return;
      const safeFragment = sanitizeHtmlToFragment(htmlString);
      container.replaceChildren(safeFragment);
    }

    async function customWidget(variantId) {
      let dataId = document.querySelector('.cross_products-wrapper')?.dataset.widgetId;
      let variantID = variantId;
      let productId = document.querySelector('custom-product').dataset.productId;
      let matchOption = document.querySelector('.select-popout__list__scroll .select-popout__item--current span')?.textContent.trim() || '';

      const res = await fetch(`https://wapi.zinus.com/api/rebuy-proxy?data_id=${encodeURIComponent(dataId)}&product_ids=${encodeURIComponent(productId)}&variant_ids=${encodeURIComponent(variantID)}`);
      const data = await res.json();

      let crossProducts = data.data || [];
      let productsBody = '';

      crossProducts.forEach(item => {
        let descriptions = '';
        let hideVariants = '';

        if (item.metafields) {
          item.metafields.forEach(metafield => {
            if (metafield.key == 'cross_description') {
              descriptions = metafield.value || '';
            }
          });
        }

        if (item.id == '7691544461375') {
          hideVariants = 'hidden';
        }

        const safeItemTitle = escapeHtml(item.title || '');
        const safeItemImage = safeImageUrl(item.image?.src || '');
        const safeItemId = escapeHtml(item.id || '');
        const safeItemHandle = escapeHtml(item.handle || '');
        const safeVariantSku = escapeHtml(item.variants?.[0]?.sku || '');
        const safeVariantId = escapeHtml(item.variants?.[0]?.id || '');
        const safeDescriptions = escapeHtml(descriptions || '');

        let firstSelectedColorName = '';

        productsBody += `
          <li class="product__form" data-product-part="">
            <input type="hidden" name="id" value="${safeVariantId}" data-product-select="" data-product-available="true">
            <div class="cross_product-item" role="group" aria-label="product" data-product-id="${safeItemId}" data-handle="${safeItemHandle}">
              <div class="cross_product-image">
                <img src="${safeItemImage}" width="100" height="100" alt="${safeItemTitle}">
              </div>
              <div class="cross_product-details" data-variant-sku="${safeVariantSku}">
                <div class="title-with-price">
                  <button class="cross_product-checked" type="button">
                    <span class="icon-plus" aria-hidden="true">
                      <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m13.5113 6.026h-5.53803v-5.538h-1.924v5.538h-5.563996v1.924h5.563996v5.564h1.924v-5.564h5.53803z" fill="currentColor"></path></svg>
                    </span>
                    <span class="add_button">Add</span>
                  </button>
                  ${
                    item.variants.map((card, index) => {
                      let option = '';
                      let hideComparePrice = '';
                      let variantName = card.title || '';

                      if (!variantName.includes(matchOption) || index > 0) {
                        option = 'hidden';
                      }

                      if (card.compare_at_price === card.price || !card.compare_at_price) {
                        hideComparePrice = 'hidden';
                      }

                      return `
                        <div class="price-wrapper ${escapeHtml(option)}" role="button" tabindex="0" data-variant-name="${escapeHtml(variantName)}" data-variant-id="${escapeHtml(card.id || '')}" data-inventory-quantity="${escapeHtml(card.inventory_quantity || '')}">
                          <h3 class="product_title">${safeItemTitle}</h3>
                          <div class="variant-with-price">
                            <span class="variant_option">(${escapeHtml(matchOption)})</span>
                            <span class="variant_price" data-price="${escapeHtml(card.price || '')}">$${escapeHtml(card.price || '')}</span>
                            <span class="product__price--compare ${escapeHtml(hideComparePrice)}">$${escapeHtml(card.compare_at_price || '')}</span>
                          </div>
                        </div>`;
                    }).join('')
                  }
                </div>
                <div class="item_options ${escapeHtml(hideVariants)}">
                  ${
                    item.options.map(option => {
                      if (option.name.trim() != 'Size' && option.name.trim() != 'size') {
                        if (option.name.trim() == 'Color') {
                          const safeOptionName = escapeHtml(option.name || '');
                          let returnText = `<fieldset class="radio__fieldset" role="radiogroup" aria-labelledby="color-label-${safeOptionName}"><legend id="color-label-${safeOptionName}" class="sr-only">Choose a color</legend>`;

                          for (let index in option.values) {
                            let colorName = String(option.values[index] || '').toLowerCase();
                            let hexColor = getHexValue(dataColors, colorName) || {};
                            let hexValue = safeColor(hexColor[colorName] || '');
                            let colorType = hexColor.type;
                            let colorTypeValue = '';

                            if (colorType == 'dark') {
                              colorTypeValue = 'dark';
                            } else if (colorType == 'light') {
                              colorTypeValue = 'light';
                            }

                            let currentItem = '';
                            let ariaChecked = 'false';
                            let optionValue = String(option.values[index] || '').replaceAll(' ', '-');
                            let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;
                            let name = `${option.name}--${option.product_id}`;

                            if (Number(index) === 0) {
                              currentItem = 'checked';
                              ariaChecked = 'true';
                              firstSelectedColorName = String(option.values[index] || '');
                            }

                            returnText += `
                              <span class="swatch__button" data-tooltip="${escapeHtml(option.values[index] || '')}">
                                <input
                                  type="radio"
                                  class="swatch__input variant_radio_input"
                                  data-single-option-selector
                                  data-index="option"
                                  name="${escapeHtml(name)}"
                                  value="${escapeHtml(option.values[index] || '')}"
                                  id="${escapeHtml(input_id)}"
                                  aria-checked="${ariaChecked}"
                                  ${currentItem}>
                                <label
                                  for="${escapeHtml(input_id)}"
                                  class="swatch__label ${escapeHtml(colorTypeValue)}"
                                  title="${escapeHtml(option.values[index] || '')}"
                                  data-swatch="${escapeHtml(option.values[index] || '')}"
                                  style="background-color: ${hexValue};">
                                  <span class="visually-hidden">${escapeHtml(option.values[index] || '')}</span>
                                </label>
                              </span>`;
                          }

                          returnText += `</fieldset><p>Color: <strong class="selected_color-name">${escapeHtml(firstSelectedColorName)}</strong></p>`;
                          return returnText;
                        } else {
                          let ariaLabelledby = `select-${option.name}-label`;
                          let ariaControls = `select-${option.name}`;
                          let returnText = `
                            <select-popout class="select-popup__item select-popout">
                              <label id="height-label" class="sr-only">Select Height</label>
                              <button type="button" class="select-popout__toggle" role="combobox" aria-controls="${escapeHtml(ariaControls)}" aria-labelledby="height-label select-popout-text" aria-activedescendant="custom-option-0" aria-expanded="false" aria-haspopup="listbox">
                                <span id="select-popout-text" class="select-popout__value" data-popout-text>${escapeHtml(option.values?.[0] || '')}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon-select" width="24" height="24" viewBox="0 0 24 24">
                                  <polygon points="12 17.414 3.293 8.707 4.707 7.293 12 14.586 19.293 7.293 20.707 8.707 12 17.414"/>
                                </svg>
                              </button>
                              <ul class="select-popout__list custom-select-popout__list__scroll select-popout__list__scroll" id="${escapeHtml(ariaLabelledby)}" aria-labelledby="height-label" role="listbox" tabindex="-1" data-popout-list>`;

                          for (let index in option.values) {
                            let currentItem = '';
                            let ariaSelected = 'false';

                            if (Number(index) === 0) {
                              currentItem = 'select-popout__item--current';
                              ariaSelected = 'true';
                            }

                            returnText += `
                              <li class="select-popout__item ${escapeHtml(currentItem)}" role="option" id="custom-option-${escapeHtml(index)}" aria-selected="${ariaSelected}">
                                <span class="select-popout__option" data-value="${escapeHtml(option.values[index] || '')}" data-popout-option>
                                  <span data-value="${escapeHtml(option.values[index] || '')}">${escapeHtml(option.values[index] || '')}</span>
                                </span>
                              </li>`;
                          }

                          returnText += `</ul></select-popout>`;
                          return returnText;
                        }
                      }

                      return '';
                    }).join('')
                  }
                </div>
                <div class="cross_product-description"><p>${safeDescriptions}</p></div>
              </div>
            </div>
          </li>`;
      });

      document.querySelector('.cross_products-wrapper').innerHTML = productsBody;

      productWidget();

      document.querySelectorAll('.rebuy_cross-wrapper .cross_product-item').forEach(item => {
        let popoutText = document.querySelector('.select-popout__item--current span')?.textContent?.trim() || '';
        let variantTitle = item.querySelector('.title-with-price .price-wrapper')?.dataset.variantName || '';
        if (variantTitle.includes(popoutText)) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
        if (item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.inventoryQuantity < 1) {
          item.classList.add('hidden');
        }
      });

      document.querySelectorAll('.rebuy_cross-wrapper .select-popout__toggle').forEach(item => {
        item.addEventListener('keydown', (e) => {
          switch (e.key) {
            case 'ArrowUp':
              e.preventDefault();
              selectPreviousOption(item);
              break;

            case 'ArrowDown':
              e.preventDefault();
              selectNextOption(item);
              break;

            case 'Tab':
              item.setAttribute('aria-expanded', false);
              item.closest('.select-popout').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
              break;

            case 'Escape':
              e.preventDefault();
              item.closest('.select-popout').querySelector('.select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
              break;

            case 'Enter':
              e.preventDefault();
              if (item.closest('.select-popout').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')) {
                item.closest('.select-popout').querySelector('.select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
              } else {
                item.setAttribute('aria-expanded', true);
                item.closest('.select-popout').querySelector('.select-popout__list').classList.add('select-popout__list--visible');
              }
              break;
          }
        });
      });

      rebuyOptionSelector();
      crossKeydown();
      crossProductKeyBoard();
    }

    function getHexValue(dataColors, colorName) {
    // Loop through each object in the array
      for (const color of dataColors) {
        // Check if the color name exists in the object
        if (color[colorName]) {
          return color; // Return the hex value
        }
      }
      
    }

    function getColorValue(dataColors, colorName) {
      // Loop through each object in the array
      for (const color of dataColors) {
        // Check if the color name exists in the object
        if (color[colorName]) {
          return color[colorName]; // Return the hex value
        }
      }
      
    }

    document.querySelector('.custom_checkbox').addEventListener('keydown', (e) => {
      if(e.code == 'Space' || e.key == 'Enter'){
        e.preventDefault();
        e.stopPropagation();
        let checkbox = document.querySelector('.custom_checkbox');
        let isChecked = checkbox.getAttribute('aria-checked') === 'true';
        checkbox.setAttribute('aria-checked', !isChecked);
        document.querySelector('.cross_widget #cross_widget').click();
      }
    })

    /* keyboard function */

    function keyDown(){
      document.querySelectorAll('.select-popout__toggle').forEach(item => {
        item?.addEventListener('keydown', (e) => {
          switch(e.key) {
              case 'ArrowUp':
                  e.preventDefault();
                  selectPreviousOption(item);
                  break;
    
              case 'ArrowDown':
                  e.preventDefault();
                  selectNextOption(item);
                  break;

              case 'Tab':
                  item.setAttribute('aria-expanded', false);
                  item.closest('select-popout').querySelector('.zin-select-popout__list').classList.remove('select-popout__list--visible');
              break;
                  
              case 'Escape':
                e.preventDefault();
                item.closest('.select-popout').querySelector('.custom-select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
                document.querySelector('.select-popout__toggle').focus();
              break;

              case 'Enter':
                e.preventDefault();
                if(item.closest('.select-popout').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')){
                  item.closest('.select-popout').querySelector('.custom-select-popout__list__scroll .select-popout__item--current .select-popout__option').click();
                }else{
                  item.setAttribute('aria-expanded', true);
                  item.closest('.select-popout').querySelector('.select-popout__list').classList.add('select-popout__list--visible');
                }
              break;
          }
        });
      })
    }

    function selectPreviousOption(item) {
      let currentOption = item.closest('.select-popout').querySelector('.select-popout__item--current');
      let options = item.closest('.select-popout').querySelectorAll('.custom-select-popout__list__scroll .select-popout__item');
      if (currentOption) {
          const currentOptionIndex = Array.prototype.indexOf.call(options, currentOption);
          if (currentOptionIndex - 1 >= 0) {
              const previousOption = options[currentOptionIndex - 1];
              currentOption.classList.remove('select-popout__item--current');
              previousOption.classList.add('select-popout__item--current'); // Select the previous option
              document.querySelectorAll('.custom-select-popout__list__scroll .select-popout__item').forEach(element =>{
                element.setAttribute('aria-selected', false);
              })
              previousOption.setAttribute('aria-selected', true);
              let id = previousOption.getAttribute('id');
              previousOption.closest('select-popout').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', id)
          }
      }
    }

    function selectNextOption(item) {
      let currentOption = item.closest('.select-popout').querySelector('.select-popout__item--current');
      let options = item.closest('.select-popout').querySelectorAll('.custom-select-popout__list__scroll .select-popout__item');
      if(currentOption !== undefined) {
        var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
        if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            currentOption.classList.remove('select-popout__item--current');
            document.querySelectorAll('.custom-select-popout__list__scroll .select-popout__item').forEach(element =>{
              element.setAttribute('aria-selected', false);
            })
            nextOption.classList.add('select-popout__item--current'); // Select the previous option
            nextOption.setAttribute('aria-selected', true);
            let id = nextOption.getAttribute('id');
            nextOption.closest('select-popout').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', id)
        }
      }
    }

    function crossKeydown() {
      document.querySelectorAll('.cross_products-wrapper .swatch__label').forEach(item => {
        item?.addEventListener('keydown', (e) => {
          if(e.code == 'Space' || e.key == 'Enter'){
            e.preventDefault();
            item.closest('.swatch__button').querySelector('.swatch__input').click();
          }
          if(e.code == 'Escape'){
            item.blur();
          }
        });
      })
    }

    function crossProductKeyBoard() {
      document.querySelectorAll('.cross_product-item .price-wrapper').forEach((element) => {
        element?.addEventListener('keydown', (e) => {
          if (e.code === 'Space' || e.key === 'Enter') {
            if (e.target.classList.contains('price-wrapper')) {
                  e.preventDefault();
                  e.stopPropagation();

                  let item = element.closest('.cross_product-item');
                  if (!item) return;

                  let parentProductPart = item.closest('[data-product-part]');
                  if (!parentProductPart) return;

                  let productHandle = item.dataset.handle;
                  let productSelect = parentProductPart.querySelector('[data-product-select]');
                  if (!productHandle || !productSelect) return;

                  let selectedVariantId = productSelect.value;
                  let checkAddButton = '';
                  let textButton = 'Add';

                  let details = item.querySelector('.cross_product-details');
                  let productTitleEl = details?.querySelector('.product_title');
                  let variantPriceEl = details?.querySelector('.variant-with-price .variant_price');

                  let variantTitle = productTitleEl?.textContent.trim() || '';
                  let variantPrice = variantPriceEl?.dataset.price || '';
                  let variantSku = details?.dataset.variantSku || '';
                  let variantId = productSelect.value;

                  const container = enableMulberryUpsell ? '.popup-mulberry-inner' : null;

                  const mulberryHiddenMarkup = enableMulberryUpsell
                    ? '<div class="mulberry-id"></div><input type="hidden" class="mulberry-product-id" name="properties[mulberry]" value="" />'
                    : '';

                  const quickViewMulberryMarkup = enableMulberryUpsell
                    ? '<div class="popup-mulberry-inner"></div><span class="quick_purchase_button" role="button" tabindex="0">I don&#39;t want to protect my purchase</span>'
                    : '';

                  if (item.querySelector('.cross_product-checked')?.classList.contains('button_clicked')) {
                    checkAddButton = 'button_clicked';
                    textButton = 'Added';
                  }

                  let productsBody = '';
                  let quickViewDescriptionHtml = '';
                  let getMetafieldsUrl = `https://zinus.com/products/${encodeURIComponent(productHandle)}?view=view`;

                  fetch(getMetafieldsUrl)
                    .then((response) => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok: ' + response.statusText);
                      }
                      return response.text();
                    })
                    .then((html) => {
                      quickViewDescriptionHtml = html || '';

                      let productUrl = `https://zinus.com/products/${encodeURIComponent(productHandle)}.js`;
                      let sizeValue = document.querySelector('.select-popout__item--current span')?.textContent.trim() || '';

                      fetch(productUrl)
                        .then((response) => {
                          if (!response.ok) {
                            throw new Error('Network response was not ok ' + response.statusText);
                          }
                          return response.json();
                        })
                        .then((data) => {
                          let item = data;
                          if (!item) return;

                          const safeFeaturedImage = safeImageUrl(item.featured_image || '');
                          const safeTitle = escapeHtml(item.title || '');
                          const safeHandle = escapeHtml(item.handle || '');
                          const safeSelectedVariantId = escapeHtml(selectedVariantId || '');
                          const safeSizeValue = escapeHtml(sizeValue || '');
                          const safeTextButton = escapeHtml(textButton || '');

                          productsBody += `
                            <button type="button" class="close_popup" aria-label="Close dialog">
                              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192">
                                <path d="M150 42 42 150M150 150 42 42" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
                              </svg>
                            </button>
                            <form method="post" action="/cart/add" class="product__form" enctype="multipart/form-data" data-product-form="" data-product-part>
                              <input type="hidden" name="id" value="${safeSelectedVariantId}" data-product-select="">
                              <input type="hidden" class="rebuy-attribution" name="properties[_attribution]" value="Rebuy Product" />
                              <input type="hidden" class="rebuy-source" name="properties[_source]" value="Rebuy" />
                              <input type="hidden" class="rebuy-widget-id" name="properties[_widget_id]" value="166634" />
                              ${mulberryHiddenMarkup}
                              <div class="cross_product-item" data-product-id="${escapeHtml(item.id || '')}" data-handle="${safeHandle}">
                                <div class="rebuy-quick-view__body__inner">
                                  <div class="cross_product-image">
                                    <img src="${safeFeaturedImage}" alt="${safeTitle}">
                                  </div>
                                </div>
                                <div class="cross_product-details">
                                  <label for="cross_product">
                                    <span class="product_title">${safeTitle}</span>
                                  </label>
                                  <div class="item_options">
                                    ${
                                      (item.options || []).map((option) => {
                                        if (!option || !option.name) return '';

                                        const safeOptionName = escapeHtml(option.name);

                                        if (option.name.trim() === 'Color') {
                                          let returnText = `<label>${safeOptionName}</label><fieldset class="radio__fieldset">`;

                                          for (let index in option.values) {
                                            let rawValue = option.values[index] || '';
                                            let colorName = rawValue.toLowerCase();
                                            let hexColor = getHexValue(dataColors, colorName) || {};
                                            let hexValue = safeColor(hexColor[colorName] || '');
                                            let colorType = hexColor.type || '';
                                            let colorTypeValue = '';

                                            if (colorType === 'dark') {
                                              colorTypeValue = 'dark';
                                            } else if (colorType === 'light') {
                                              colorTypeValue = 'light';
                                            }

                                            let currentItem = '';
                                            let optionValue = String(rawValue).replace(/\s+/g, '-');
                                            let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;

                                            if (Number(index) === 0) {
                                              currentItem = 'checked';
                                            }

                                            returnText += `
                                              <span class="swatch__button">
                                                <input
                                                  type="radio"
                                                  class="swatch__input variant_radio_input sr-only"
                                                  data-single-option-selector
                                                  data-index="option"
                                                  name="${escapeHtml(option.name)}"
                                                  value="${escapeHtml(rawValue)}"
                                                  id="${escapeHtml(input_id)}"
                                                  ${currentItem}
                                                >
                                                <label
                                                  for="${escapeHtml(input_id)}"
                                                  class="swatch__label ${escapeHtml(colorTypeValue)}"
                                                  data-swatch="${escapeHtml(rawValue)}"
                                                  data-tooltip="${escapeHtml(rawValue)}"
                                                  ${hexValue ? `style="background-color: ${hexValue};"` : ''}
                                                  tabindex="0"
                                                >
                                                  <span class="visually-hidden">${escapeHtml(rawValue)}</span>
                                                </label>
                                              </span>
                                            `;
                                          }

                                          returnText += `</fieldset>`;
                                          return returnText;
                                        }

                                        if (option.name.trim() !== 'Size') {
                                          let returnText = `
                                            <fieldset class="radio__fieldset">
                                              <legend class="radio__legend">
                                                <span class="radio__legend__label">${safeOptionName}</span>
                                              </legend>
                                          `;

                                          for (let index in option.values) {
                                            let rawValue = option.values[index] || '';
                                            let currentItem = '';
                                            let optionValue = String(rawValue).replace(/\s+/g, '-');
                                            let input_id = `${option.id}-${option.product_id}-${option.name}-${optionValue}`;

                                            if (Number(index) === 0) {
                                              currentItem = 'checked';
                                            }

                                            returnText += `
                                              <span class="radio__button">
                                                <input
                                                  type="radio"
                                                  class="radio__input variant_radio_input sr-only"
                                                  data-single-option-selector
                                                  data-index="option"
                                                  name="${escapeHtml(option.name)}"
                                                  value="${escapeHtml(rawValue)}"
                                                  id="${escapeHtml(input_id)}"
                                                  ${currentItem}
                                                >
                                                <label for="${escapeHtml(input_id)}" class="radio__label">
                                                  <span>${escapeHtml(rawValue)}</span>
                                                </label>
                                              </span>
                                            `;
                                          }

                                          returnText += `</fieldset>`;
                                          return returnText;
                                        }

                                        return '';
                                      }).join('')
                                    }
                                  </div>
                                  <div class="title-with-price">
                                    ${
                                      (item.variants || []).map((card, index) => {
                                        if (index >= 1) return '';

                                        let option = '';
                                        let hideComparePrice = '';
                                        let variantName = escapeHtml(card.title || '');
                                        let cardPrice = Number((card.price || 0) / 100).toFixed(2);
                                        let compareAtPrice = card.compare_at_price
                                          ? Number(card.compare_at_price / 100).toFixed(2)
                                          : '';

                                        if (card.compare_at_price === card.price || !card.compare_at_price) {
                                          hideComparePrice = 'hidden';
                                        }

                                        return `
                                          <div
                                            class="price-wrapper ${option}"
                                            data-variant-name="${variantName}"
                                            data-variant-id="${escapeHtml(card.id || '')}"
                                            data-inventory-quantity="${escapeHtml(card.inventory_quantity || '')}"
                                          >
                                            <div class="variant-with-price">
                                              <span class="sizeValue">(${safeSizeValue})</span>
                                              <span class="variant_price" data-price="${escapeHtml(cardPrice)}">$${escapeHtml(cardPrice)}</span>
                                              <span class="product__price--compare ${hideComparePrice}">
                                                ${compareAtPrice ? `$${escapeHtml(compareAtPrice)}` : ''}
                                              </span>
                                            </div>
                                          </div>
                                        `;
                                      }).join('')
                                    }
                                    <button class="cross_product-checked ${escapeHtml(checkAddButton)}" type="submit" name="add" data-add-to-cart>
                                      <span class="icon-plus"></span>
                                      <span class="add_button">${safeTextButton}</span>
                                    </button>
                                  </div>
                                  ${quickViewMulberryMarkup}
                                  <div class="product_description"></div>
                                </div>
                              </div>
                            </form>
                          `;

                          const popupWrapper = document.querySelector('.rebuy_popup-wrapper');
                          if (!popupWrapper) return;

                          popupWrapper.innerHTML = productsBody;

                          const plusIconContainer = popupWrapper.querySelector('.icon-plus');
                          if (plusIconContainer) {
                            plusIconContainer.replaceChildren(createUpsellIcon());
                          }

                          const productDescriptionContainer = popupWrapper.querySelector('.product_description');
                      setSanitizedHtml(productDescriptionContainer, quickViewDescriptionHtml);

                      popupVariantSwap();
                      productPopupWidget();

                      openRebuyPopupModal(element);

                      popupWrapper.querySelector('.close_popup')?.addEventListener('click', closeRebuyPopupModal);

                      if (enableMulberryUpsell) {
                        popupWrapper.querySelector('.quick_purchase_button')?.addEventListener('click', function () {
                          const mulberryId = popupWrapper.querySelector('.mulberry-id');
                          if (mulberryId) {
                            mulberryId.innerHTML = '';
                          }
                          popupWrapper.querySelector('.cross_product-checked')?.click();
                        });

                        initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
                      }
                    })
                    .catch((error) => {
                      console.error('There was a problem with the fetch operation:', error?.message);
                    });
                })
                .catch((error) => {
                  console.error('There was a problem with the fetch operation:', error?.message);
                });
            }
          }
        });
      });
    }

    async function checkForMulberryToken(ms = 100, triesLeft = 100) {
      return new Promise((resolve, reject) => {
        if (window?.mulberry?.core?.publicToken) {
          resolve(true);
        }
        const interval = setInterval(async () => {
          if (window?.mulberry?.core?.publicToken) {
            resolve(true);
            clearInterval(interval);
          } else if (triesLeft <= 1) {
            resolve(false);
            clearInterval(interval);
          }
          triesLeft--;
        }, ms);
      });
    }

    async function initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container) {
      if (!enableMulberryUpsell) return;
      let loadingOverlay = document.getElementById('modal-loading-overlay');
      const rebuyMulberryInline = document.querySelector('.rebuy-mulberry-inline');
      if (rebuyMulberryInline) {
        rebuyMulberryInline.innerHTML = '';
      }
      // Add null checks
      let popupMulberry = document.querySelector('.popup-mulberry-inner');
      if (popupMulberry) {
        popupMulberry.innerHTML = '';
      }
      const mulberryWrapperId = document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id');
      if (mulberryWrapperId) {
        mulberryWrapperId.innerHTML = '';
      }
      let mulberryProductIds = document.querySelectorAll('.mulberry-product-id');
      if(!mulberryProductIds) return;
      mulberryProductIds.forEach(item =>{
        item.value='';
      })
      if(document.querySelector('.rebuy_popup-wrapper .mulberry-id')){
        document.querySelector('.rebuy_popup-wrapper .mulberry-id').innerHTML = '';
      }
      window.mulberry.core.init({
        publicToken: 'zLHKJyjbN1MyxRnXHwSvcgq-gMk'
      });
      async function setMulberrySelectedWarranty(warranty) {
        let mulberrySelectedWarranty = warranty;

        function setMulberryHiddenInput(container, variantId) {
          if (!container) return;

          container.replaceChildren();

          if (!variantId && variantId !== 0) return;

          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[1][id]';
          input.value = String(variantId);
          input.setAttribute('data-mulberry-id', '');

          container.appendChild(input);
        }

        function clearMulberryHiddenInput(container) {
          if (!container) return;
          container.replaceChildren();
        }

        if (mulberrySelectedWarranty) {
          try {
            const params = new URLSearchParams({
              product_price: String(mulberrySelectedWarranty.product.price),
              duration_months: String(mulberrySelectedWarranty.duration_months),
              insurer_category: String(mulberrySelectedWarranty.insurer_category)
            });

            const response = await fetch(`https://ottawa.getmulberry.com/api/prices?${params}`, {
              method: 'GET',
              headers: {
                'Authorization': 'Bearer zLHKJyjbN1MyxRnXHwSvcgq-gMk',
                'Content-Type': 'application/json'
              }
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const shopifyMulberryVariantId = data.shopify_variant_id;

            const inlineContainer = document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id');
            const popupContainer = document.querySelector('.rebuy_popup-wrapper .mulberry-id');

            setMulberryHiddenInput(inlineContainer, shopifyMulberryVariantId);
            setMulberryHiddenInput(popupContainer, shopifyMulberryVariantId);

            document.querySelectorAll('.mulberry-product-id').forEach((item) => {
              item.value = String(shopifyMulberryVariantId);
            });
          } catch (error) {
            console.error('Unable to fetch mulberry variant ID', error?.message);
          }
        } else {
          clearMulberryHiddenInput(document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id'));
          clearMulberryHiddenInput(document.querySelector('.rebuy_popup-wrapper .mulberry-id'));
        }
      }

      checkForMulberryToken();
    
      const offers = await mulberry.core.getWarrantyOffer({
        title: variantTitle,
        id: variantSku,
        price: variantPrice
      });
      document.querySelectorAll('.mulberry-popup [data-product-id]').forEach(item =>{
        item.value = variantId;
      })
      mulberry.inline.init({
        offers: offers,
        settings: mulberry.core.settings,
        selector: container,
        onWarrantyToggle: warranty => {
          if (warranty.isSelected) {
            return setMulberrySelectedWarranty(warranty.offer);
          }

          setMulberrySelectedWarranty(null);
        }
      });
      if(container == '.rebuy-mulberry-inline'){
        setTimeout(() => {
          document.querySelector('.mulberry-popup').classList.add('active');
          loadingOverlay?.classList.remove('is-visible');
          const mulberryPopup = document.querySelector('.mulberry-popup');
          mulberryPopup.classList.add('active');
          mulberryPopup.setAttribute('aria-hidden', 'false');

          /* ADD THIS LINE */
          focusModalCloseButton('mulberry');   
        }, 1000);
      }else{
        setTimeout(() => {
          focusModalCloseButton('rebuy');
        }, 1000);
      }
    }

    function addRebuyUpsellToCart(variantId) {
      if (!variantId) return;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('properties[_attribution]', rebuyUpsellProperties.attribution);
      formData.append('properties[_source]', rebuyUpsellProperties.source);
      formData.append('properties[_widget_id]', rebuyUpsellProperties.widgetId);

      const cartAddUrl = window.theme?.routes?.cart_add_url
        || `${window.Shopify?.routes?.root || '/'}cart/add.js`;

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          if (data?.status) {
            console.error(`Rebuy upsell add failed: ${data?.message || 'Unknown error'}`);
            return;
          }
          if (window.cart && typeof window.cart.getCart === 'function') {
            window.cart.getCart();
          }
        })
        .catch(error => {
          console.error(`Rebuy upsell add failed: ${error?.message || 'Unknown error'}`);
        });
    }

    function productWidget(){
      let loadingOverlay = document.getElementById('modal-loading-overlay');
      let rebuyCards = document.querySelectorAll('.rebuy_cross-wrapper .cross_product-checked');
      if(!rebuyCards) return;
      rebuyCards.forEach((item, index) => {
        item.addEventListener('click', function(e){
          let productId = item.closest('.cross_product-item').dataset.productId;
          if(item.classList.contains('button_clicked')){
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
              card.querySelector('.add_button').textContent = 'Add';
            })
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove'))
              document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove').click();
          }else{
            if (enableMulberryUpsell) {
              loadingOverlay?.classList.add('is-visible');
            }
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.add('button_clicked');
              card.querySelector('.add_button').textContent = 'Added';
            })
            let variantTitle = item.closest('.cross_product-details').querySelector('.product_title').textContent.trim();
            let variantPrice = item.closest('.cross_product-details').querySelector('.variant-with-price .variant_price').dataset.price;
            let variantSku = item.closest('.cross_product-details').dataset.variantSku;
            let variantId = item.closest('[data-product-part]').querySelector('[data-product-select]').value;
            if (enableMulberryUpsell) {
              let container = '.rebuy-mulberry-inline';
              initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
              const closeButton = document.querySelector('.close_mulberry_popup');
              if (closeButton) {
                closeButton.dataset.productId = productId;
              }
              document.querySelector('.mulberry-add-button')?.addEventListener('click', function(){
                document.querySelector('.mulberry-popup')?.classList.remove('active');
              })

              document.querySelector('.purchase_button')?.addEventListener('click', function(){
                document.querySelector('.rebuy-mulberry-inline_wrapper .mulberry-id').innerHTML = '';
                document.querySelector('.mulberry-add-button')?.click();
              })
            } else {
              addRebuyUpsellToCart(variantId);
            }
          }
        })
      })
    }

    function focusModalCloseButton(modalType) {
      let overlay, modal, closeSelector;

      if (modalType === 'mulberry') {
        overlay = document.querySelector('.mulberry-popup');
        modal = overlay?.querySelector('.rebuy-mulberry-inline_wrapper');
        closeSelector = '.close_mulberry_popup';
      } else if (modalType === 'rebuy') {
        overlay = document.querySelector('.popup-overlay');
        modal = overlay?.querySelector('.rebuy_popup-wrapper');
        closeSelector = '.close_popup';
      }

      if (!overlay || !modal) return;

      let tries = 0;
      const maxTries = 20;

      const timer = setInterval(() => {
        tries++;

        const closeBtn = modal.querySelector(closeSelector);

        if (closeBtn) {
          clearInterval(timer);

          // Add dialog semantics (safe + helps SR)
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');

          closeBtn.focus();

          // Bind focus trap once
          trapFocusInModal(modal);

          // Bind ESC close once (for this overlay)
          enableEscapeToClose(overlay, closeBtn);

        } else if (tries >= maxTries) {
          clearInterval(timer);
        }
      }, 50);
    }

    function trapFocusInModal(modal) {
      if (!modal || modal._focusTrapBound) return; // prevent duplicate listeners
      modal._focusTrapBound = true;

      modal.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;

        const items = Array.from(
          modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]'
          )
        );

        if (!items.length) return;

        const first = items[0];
        const last = items[items.length - 1];

        // If focus escaped, pull it back in
        if (!modal.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
          return;
        }

        // Shift+Tab on first -> last
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
          return;
        }

        // Tab on last -> first
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
          return;
        }
      });
    }

    function enableEscapeToClose(overlay, closeBtn) {
      if (!overlay || overlay._escBound) return; // prevent duplicate listeners
      overlay._escBound = true;

      // Make sure overlay can receive key events if needed
      if (!overlay.hasAttribute('tabindex')) {
        overlay.setAttribute('tabindex', '-1');
      }

      overlay.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        e.preventDefault();
        closeBtn?.click();
      });
    }

    let rebuyPopupTrigger = null;

    function getRebuyPopupDialog() {
      return document.querySelector('.rebuy_popup-wrapper [role="dialog"]')
        || document.querySelector('.rebuy_popup-wrapper');
    }

    function onRebuyOverlayClick(e) {
      if (e.target.classList.contains('popup-overlay')) {
        closeRebuyPopupModal();
      }
    }

    function openRebuyPopupModal(triggerEl) {
      const overlay = document.querySelector('.popup-overlay');
      const dialog = getRebuyPopupDialog();
      const closeBtn = dialog?.querySelector('.close_popup');
      if (!overlay || !dialog) return;

      rebuyPopupTrigger = triggerEl || document.activeElement;

      overlay.classList.add('active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow');

      trapFocusInModal(dialog);
      enableEscapeToClose(overlay, closeBtn);

      overlay.removeEventListener('click', onRebuyOverlayClick);
      overlay.addEventListener('click', onRebuyOverlayClick);

      requestAnimationFrame(() => {
        closeBtn?.focus();
      });
    }

    function closeRebuyPopupModal() {
      const overlay = document.querySelector('.popup-overlay');
      if (!overlay) return;

      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow');
      overlay.removeEventListener('click', onRebuyOverlayClick);

      if (rebuyPopupTrigger && typeof rebuyPopupTrigger.focus === 'function') {
        rebuyPopupTrigger.focus();
      }
      rebuyPopupTrigger = null;
    }
    
    const mulberryCloseButton = document.querySelector('.close_mulberry_popup');
    if (enableMulberryUpsell && mulberryCloseButton) {
      mulberryCloseButton.addEventListener('click', function(){
        let productId = this.dataset.productId;
        document.querySelector('.mulberry-popup').classList.remove('active');
        document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
          card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
          card.querySelector('.add_button').textContent = 'Add';
        })
      })
    }

    function productPopupWidget(){
      let rebuyPopUpCards = document.querySelectorAll('.rebuy_popup-wrapper .cross_product-checked');
      if(!rebuyPopUpCards) return;
      rebuyPopUpCards.forEach((item, index) => {
        item.addEventListener('click', function(e){
          let productId = item.closest('.cross_product-item').dataset.productId;
          if(item.classList.contains('button_clicked')){
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.remove('button_clicked');
              card.querySelector('.add_button').textContent = 'Add';
            })
            e.preventDefault();
            e.stopPropagation();
            if(document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove'))
              document.querySelector(`.cart-drawer__items .cart__item__content[data-item-id="${productId}"]`).querySelector('.cart__item__remove').click();
          }else{
            const rebuyMulberryInline = document.querySelector('.rebuy-mulberry-inline');
            if (rebuyMulberryInline) {
              rebuyMulberryInline.innerHTML = '';
            }
            document.querySelectorAll(`.cross_product-item[data-product-id="${productId}"]`).forEach(card => {
              card.closest('[data-product-part]').querySelector('.cross_product-checked').classList.add('button_clicked');
              card.querySelector('.add_button').textContent = 'Added';
            })
            
          }

        })
      })
    }

    document.querySelectorAll('.zin-radio__button').forEach(item => {
      item.querySelector('.zin-radio__label')?.addEventListener('keydown', (e) => {
        switch(e.key) {
            case 'Enter':
              e.preventDefault();
              localStorage.setItem('zinusSelectedRadio', item.id);
              item.querySelector('.radio__input').click();
            break;
        }
      });
    })
    const savedId = localStorage.getItem('zinusSelectedRadio');
    if (savedId) {
      const input = document.getElementById(savedId);
      if (input) {
        input.focus();
        input.checked = true;
      }
      localStorage.removeItem("zinusSelectedRadio")
    }

    if (typeof window.zinusOnSwiperReady === 'function') {
      window.zinusOnSwiperReady(initSwiper);
    } else {
      initSwiper();
    }

    keyDown();

    initVariant();
    syncMattressSoldOutUiFromSelectedSize();
    observeMattressSoldOutClass();
    swapProduct();
    mobileSwapProduct();
    observeMattressSizeSoldOutA11y();
    window.setTimeout(function () {
      syncMattressSizeSoldOutA11y();
      syncMattressSoldOutUiFromSelectedSize();
    }, 400);
    window.setTimeout(syncMattressSoldOutUiFromSelectedSize, 1200);

    zinusScheduleIdle(function initZinusDeferredNav() {
      quickView();
    });

    let variantTotalPrice= [];

    if(document.querySelectorAll('.variants-wrapper .variant_item')){
      document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
        variantTotalPrice.push(variantItem.dataset.totalValue);
      })
    }

    if(document.querySelectorAll(".select-popout__list__scroll .price-with-total")){
      document.querySelectorAll(".select-popout__list__scroll .price-with-total").forEach((item, i) => {
        const totalPriceEl = item.querySelector('.total_price');
        const saveBadge = item.querySelector('.product__price--off');
        const savePct = Number(saveBadge?.dataset.salePercent);
        const compareValue = variantTotalPrice[i] || '';
        if (compareValue && !compareValue.includes('$0.00') && savePct > 0) {
          if (totalPriceEl) {
            totalPriceEl.textContent = `${compareValue}`;
            totalPriceEl.classList.remove('hidden');
          }
        } else if (totalPriceEl) {
          totalPriceEl.textContent = '';
          totalPriceEl.classList.add('hidden');
        }
      })
    }

    document.querySelectorAll(".select-popout__list__scroll").forEach(element => {
      element?.querySelectorAll(".price-with-total").forEach((item, i) => {
        const totalPriceEl = item.querySelector('.total_price');
        const saveBadge = item.querySelector('.product__price--off');
        const savePct = Number(saveBadge?.dataset.salePercent);
        const compareValue = variantTotalPrice[i] || '';
        if (compareValue && !compareValue.includes('$0.00') && savePct > 0) {
          if (totalPriceEl) {
            totalPriceEl.textContent = `${compareValue}`;
            totalPriceEl.classList.remove('hidden');
          }
        } else if (totalPriceEl) {
          totalPriceEl.textContent = '';
          totalPriceEl.classList.add('hidden');
        }
      })
    })

    document.querySelector('.sticky-variant_wrapper .select-popout__toggle, .ab-variant-b .select-popout__toggle')?.addEventListener('click', function(){
      let status = this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
      this.setAttribute('aria-expanded', status);
      this.closest('select-popout')?.querySelector('.zin-select-popout__list')?.classList.toggle('select-popout__list--visible');
    })

    document.querySelector('.ab-variant-b .select-popout__toggle')?.addEventListener('click', function(){
      let status = this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
      this.setAttribute('aria-expanded', status);
      this.closest('select-popout')?.querySelector('.zin-select-popout__list')?.classList.toggle('select-popout__list--visible');
    })

    document.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(button => {
      button?.addEventListener('click', function(e){
        let popoutText = this.querySelector('.select-popout__option')?.dataset.value;
        if (!popoutText) return;
        // Use the clicked size immediately (not stale --current). Queen → hide protector block.
        if (isMattressBedSizeLabel(popoutText)) {
          syncMattressProtectorUpsell(popoutText);
          this.closest('.select-popout__list__scroll')?.querySelectorAll('.select-popout__item').forEach((el) => {
            el.classList.toggle('select-popout__item--current', el === this);
          });
          // Only hide Limited Time Offer immediately when this size is already
          // marked sold out. Keep the current CTA until the live offer check
          // finishes so the upsell button is not swapped away on Full, etc.
          if (this.classList.contains('sold-out')) hideUpsellCta();
          else upsellRequestToken += 1;
        }
        let optionPrice = this.querySelector('.option_price')?.textContent;
        let totalPrice = this.querySelector('.total_price')?.textContent;
        let savePercentage = this.querySelector('.product__price--off')?.dataset.salePercent;
        let selectedId = this.getAttribute('id');
        let inventoryNumber = this.dataset.inventoryNumber;
        const qty = Number(inventoryNumber);
        const popoutRoot = this.closest('select-popout');
        const productRoot = popoutRoot?.closest('.product, .product-card, [data-product]');
        const scope = productRoot || popoutRoot || document;
        const lowStockEl = scope.querySelector('.low_in_stock');

        if (lowStockEl) {
          if (qty > 0) {
            lowStockEl.classList.remove('hidden');

            if (qty <= 95) {
              lowStockEl.textContent = `${qty} left in stock at this price`;
            } else {
              lowStockEl.textContent = 'Item in stock.';
            }
          } else {
            lowStockEl.classList.add('hidden');
          }
        }
        this.closest('select-popout')?.querySelector('.select-popout__toggle')?.setAttribute('aria-activedescendant', selectedId);
        document.querySelectorAll('.zin-select-popout__list .select-popout__list__scroll .select-popout__item').forEach(element =>{
          element.setAttribute('aria-selected', false);
        })
        this.setAttribute('aria-selected', true);

        if(document.querySelector('.cross_products-wrapper')){
          document.querySelectorAll('.cross_products-wrapper .cross_product-item').forEach(item => {
            const variantOption = item.querySelector('.variant-with-price .variant_option');
            if (variantOption) variantOption.textContent = popoutText;
            item.querySelectorAll('.title-with-price label .price-wrapper').forEach(card => {
              card.classList.add('hidden');
            })
            if(item.querySelector(`.title-with-price label .price-wrapper[data-variant-name = ${popoutText}]`)){
              item.classList.remove('hidden');
              item.querySelector(`.title-with-price label .price-wrapper[data-variant-name = ${popoutText}]`).classList.remove('hidden');
            }else{
              item.classList.add('hidden');
            }
          })

          document.querySelectorAll('.cross_product-item').forEach(item => {
            let productId = item.dataset.productId;
            let variantId = item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.variantId;
            if(document.querySelector(`.custom_widget-products [data-variant-id="${productId}"]`))
              document.querySelector(`.custom_widget-products [data-variant-id="${productId}"]`).value = variantId;
            if(item.querySelector('.title-with-price .price-wrapper:not(.hidden)')?.dataset.inventoryQuantity < 1){
              item.classList.add('hidden');
            }else{
              item.classList.remove('hidden');
            }       
          })
        }
        const stickyPopoutValue = document.querySelector('.sticky-variant_wrapper .select-popout__value');
        if (stickyPopoutValue) stickyPopoutValue.textContent = popoutText;
        document.querySelectorAll('.sticky-select-popout__item')?.forEach(item => {
          if(item.querySelector('.select-popout__option')?.dataset.value == popoutText){
            item.classList.add('select-popout__item--current');
          }else{
            item.classList.remove('select-popout__item--current');
          }
        })

        let currentId = document.querySelector('[data-current-id]')?.dataset.currentId;
        document.querySelectorAll('.product-variant__image')?.forEach(element => {
          const productCard = element.closest('.product-wrapper__item');
          productCard?.querySelector('.atc_button')?.classList.add('hidden');
          productCard?.querySelector('.shop_now')?.classList.remove('hidden');
        })
        document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.shop_now')?.classList.add('hidden');
        document.querySelector(`.find-perfect-product [data-product-id="${currentId}"]`)?.querySelector('.atc_button')?.classList.remove('hidden');
        const selectedOptionPrice = document.querySelector('.selected_option .option_price');
        if (selectedOptionPrice) selectedOptionPrice.textContent = optionPrice;
        const stickyOptionPrice = document.querySelector('.sticky-selected_option .sticky-option_price');
        if (stickyOptionPrice) stickyOptionPrice.textContent = optionPrice;
        document.querySelectorAll('.zinus-perfect-product .price-with-button .variant_price').forEach(item => {
          if(item.dataset.variantTitle?.trim().includes(popoutText)){
            item.classList.remove('hidden')
          }else{
            item.classList.add('hidden');
          }
        })
        document.querySelectorAll('.variants-wrapper .variant_item').forEach(variantItem => {
          let variantTitle = variantItem.dataset.variantTitle;
          if(variantTitle && variantTitle.includes(popoutText)){
            let mattressHeight = variantItem.dataset.height;
            variantID = variantItem.dataset.variantId;
            const selectedIdEl = document.querySelector('[data-selected-id]');
            if (selectedIdEl) selectedIdEl.dataset.selectedId = variantID;
            let savePrice = variantItem.dataset.savePrice || '';
            if(savePrice && !savePrice.includes('$0.00')){
              document.querySelectorAll('.compare_at_price').forEach(item => {
                item.textContent = '+' + savePrice;
              });
              const upgradeCompare = document.querySelector('.upgrade_product-wrapper .compare_at_price');
              if (upgradeCompare) upgradeCompare.textContent = '(+' + savePrice + ')';
            }else{
              document.querySelectorAll('.compare_at_price').forEach(item => {
                item.textContent = '';
              });
            }
            document.querySelectorAll('.mattress-height').forEach(button => {
              button.value = mattressHeight;
            })

            // popoutText is the size just clicked — do not re-read stale --current.
            syncMattressProtectorUpsell(popoutText);

            const visibleAtc = document.querySelector('.product__submit__item.atc_button:not(.hidden)');
            const cardProductSelect = visibleAtc?.closest('.price-with-button')?.querySelector('[data-product-select]');
            if (cardProductSelect) cardProductSelect.value = variantID;
            
            if(document.querySelector('.cross_products-wrapper')){
              customWidget(variantID);
            }
          }
          variantTotalPrice.push(variantItem.dataset.totalValue);
        })

        const savePct = Number(savePercentage);
        const hasPriceSavings = Boolean(totalPrice) && !totalPrice.includes('$0.00') && savePct > 0;
        const selectedTotalPrice = document.querySelector('.selected_option .total_price');
        const stickyTotalPrice = document.querySelector('.sticky-selected_option .sticky-total_price');
        const selectedSaveBadge = document.querySelector('.selected_option .product__price--off');
        const stickySaveBadge = document.querySelector('.sticky-selected_option .product__price--off');

        if (hasPriceSavings) {
          if (selectedTotalPrice) {
            selectedTotalPrice.textContent = totalPrice;
            selectedTotalPrice.classList.remove('hidden');
          }
          if (stickyTotalPrice) {
            stickyTotalPrice.textContent = totalPrice;
            stickyTotalPrice.classList.remove('hidden');
          }
          if (selectedSaveBadge) {
            selectedSaveBadge.classList.remove('hidden');
            selectedSaveBadge.textContent = `Save ${savePct}%`;
          }
          if (stickySaveBadge) {
            stickySaveBadge.classList.remove('hidden');
            stickySaveBadge.textContent = `Save ${savePct}%`;
          }
        } else {
          if (selectedTotalPrice) {
            selectedTotalPrice.textContent = '';
            selectedTotalPrice.classList.add('hidden');
          }
          if (stickyTotalPrice) {
            stickyTotalPrice.textContent = '';
            stickyTotalPrice.classList.add('hidden');
          }
          if (selectedSaveBadge) {
            selectedSaveBadge.classList.add('hidden');
            selectedSaveBadge.textContent = '';
          }
          if (stickySaveBadge) {
            stickySaveBadge.classList.add('hidden');
            stickySaveBadge.textContent = '';
          }
        }
        if(this.closest('.sticky-atc') && window.innerWidth < 767) {
          document.querySelector('.sticky-atc .select-popout__list').classList.add('select-popout__list--visible');
          document.querySelector('.sticky-atc .select-popout__toggle').setAttribute('aria-expanded', true);
        }
        if (!isMattressBedSizeLabel(popoutText)) return;
        if (unpublishedComboSelected) {
          applyMattressSoldOutUi();
          hideUpsellCta();
          return;
        }
        const productHandle = document.querySelector('[data-product-handle]')?.dataset.productHandle;
        if (!productHandle) {
          hideUpsellCta();
          return;
        }
        const endPending = beginUpsellPending();
        fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(product => {
          let variant = product.variants.find(v => v.title === popoutText)
            || product.variants.find(v => String(v.option1 || '').trim() === popoutText);
          if (!variant) {
            hideUpsellCta();
            return;
          }
          if (variant.available) {
            applyMattressInStockUi();
            return getUpsellProduct(variant.id, popoutText);
          }
          applyMattressSoldOutUi();
        })
        .catch(() => {
          hideUpsellCta();
        })
        .finally(endPending);
        
      })
    })

    function beginUpsellPending() {
      pendingUpsellCount += 1;
      if (!pendingUpsellPromise) {
        pendingUpsellPromise = new Promise((resolve) => {
          resolvePendingUpsell = resolve;
        });
      }
      return function endUpsellPending() {
        pendingUpsellCount = Math.max(0, pendingUpsellCount - 1);
        if (pendingUpsellCount === 0 && typeof resolvePendingUpsell === 'function') {
          resolvePendingUpsell();
          pendingUpsellPromise = null;
          resolvePendingUpsell = null;
        }
      };
    }

    function getVisibleUpsellCta() {
      if (isMattressSoldOutUi()) return null;
      return document.querySelector('.upsell-popup__button:not(.hidden)');
    }

    function clickOriginMattressAtc() {
      const addBtn = document.querySelector(
        '.product_add_to_cart-button .product__submit__add.atc-button, .product_add_to_cart-button .product__submit__add.actived'
      );
      if (!addBtn) return;
      allowOriginAtcClick = true;
      try {
        addBtn.focus();
        addBtn.click();
      } finally {
        allowOriginAtcClick = false;
      }
    }

    // Limited Time Offer in stock → that popup. Still loading → wait.
    // Upgrade sold out / missing → origin ATC (Mulberry).
    function routeMattressCtaClick(e) {
      if (allowOriginAtcClick) return false;
      if (isMattressSoldOutUi()) return false;

      if (pendingUpsellPromise) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        pendingUpsellPromise.then(() => {
          const laterBtn = getVisibleUpsellCta();
          if (laterBtn) laterBtn.click();
          else clickOriginMattressAtc();
        });
        return true;
      }

      const upsellBtn = getVisibleUpsellCta();
      if (upsellBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        upsellBtn.click();
        return true;
      }

      return false;
    }

    function hideUpsellCta(invalidatePending) {
      // Sold-out / size-change callers pass true so a late Rebuy response cannot
      // re-show the upgrade CTA over Notify Me. getUpsellProduct already bumped
      // the token for its own request and should pass false.
      if (invalidatePending !== false) {
        upsellRequestToken += 1;
        cachedUpsellProduct = null;
      } else {
        cachedUpsellProduct = null;
      }
      document.querySelectorAll('.upsell-popup__button').forEach((button) => {
        button.classList.add('hidden');
      });
      document.querySelector('.upgrade_widget')?.classList.add('hidden');
      document.querySelector('.product_add_to_cart-button .product__submit__item')?.classList.remove('hidden');
      document.querySelector('.sticky-add-to-cart__btn')?.classList.remove('hidden');
      const upsellIdInput = document.querySelector('.upsell-popup__container .upsell-product__id');
      if (upsellIdInput) upsellIdInput.value = '';
      const modal = document.querySelector('.upsell-popup__wrapper');
      if (modal && !modal.classList.contains('hidden')) {
        try {
          closeUpsellModal();
        } catch (err) {
          modal.classList.add('hidden');
          modal.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function getVisibleSelectedMattressSize() {
      const fromToggle = (document.querySelector('.zin-select__fieldset .select-popout__value')?.textContent || '').trim();
      if (isMattressBedSizeLabel(fromToggle)) return fromToggle;
      return getSelectedMattressSizeLabel();
    }

    function getMainMattressFormWrapper() {
      return document.querySelector('.zinus-mattress-pdp > .product__form__wrapper');
    }

    function findMattressVariantItem(sizeLabel) {
      if (!sizeLabel) return null;
      return Array.from(document.querySelectorAll('.zin-select__fieldset .variants-wrapper .variant_item')).find((el) => {
        const title = String(el.dataset.variantTitle || '').trim();
        return title === sizeLabel || title.split(' / ')[0] === sizeLabel;
      }) || null;
    }

    function isMattressSizeUnavailable(sizeLabel) {
      const variantItem = findMattressVariantItem(sizeLabel);
      if (variantItem && typeof variantItem.dataset.available !== 'undefined') {
        return variantItem.dataset.available === 'false';
      }
      if (sizeLabel && typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        const option = document.querySelector(
          `.zin-select__fieldset [data-popout-option][data-value="${CSS.escape(sizeLabel)}"]`
        );
        const item = option?.closest('.select-popout__item');
        if (item?.dataset.available === 'true') return false;
        if (item?.dataset.available === 'false') return true;
        if (item) return isMattressSizeOptionSoldOut(item);
      }
      return false;
    }

    function syncMattressSoldOutUiFromSelectedSize() {
      if (unpublishedComboSelected) {
        applyMattressSoldOutUi();
        return;
      }
      const sizeLabel = getVisibleSelectedMattressSize();
      if (!isMattressBedSizeLabel(sizeLabel)) return;
      if (isMattressSizeUnavailable(sizeLabel)) applyMattressSoldOutUi();
      else applyMattressInStockUi();
    }

    function observeMattressSoldOutClass() {
      const wrapper = getMainMattressFormWrapper();
      if (!wrapper || wrapper.dataset.soldOutSyncBound === 'true') return;
      wrapper.dataset.soldOutSyncBound = 'true';
      new MutationObserver(function () {
        if (unpublishedComboSelected) {
          if (!wrapper.classList.contains('variant--soldout')) applyMattressSoldOutUi();
          return;
        }
        const sizeLabel = getVisibleSelectedMattressSize();
        if (!isMattressBedSizeLabel(sizeLabel)) return;
        const shouldHideCta = isMattressSizeUnavailable(sizeLabel);
        const hasSoldOutClass = wrapper.classList.contains('variant--soldout');
        if (shouldHideCta === hasSoldOutClass) return;
        if (shouldHideCta) applyMattressSoldOutUi();
        else applyMattressInStockUi();
      }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    }

    function isMattressSoldOutUi() {
      return Boolean(getMainMattressFormWrapper()?.classList.contains('variant--soldout'));
    }

    function hasMattressSuccessorLink() {
      return Boolean(document.querySelector('.zinus-mattress-pdp.has-legacy-successor .legacy-soldout-message'));
    }

    // Origin (old) mattress sold out: hide Limited Time Offer and keep the successor
    // PDP link ("shop our new and improved version"). Balanced Comfort keeps Notify Me.
    // Never open Mulberry here.
    function applyMattressSoldOutUi() {
      getMainMattressFormWrapper()?.classList.add('variant--soldout');
      document.querySelector('.atc-button')?.classList.remove('actived');
      document.querySelector('.notify-button')?.classList.add('actived');
      toggleSoldOutMessage(true);
      const atcSubmit = document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add');
      if (atcSubmit) atcSubmit.disabled = true;
      hideUpsellCta();
      if (hasMattressSuccessorLink()) return;
      const stickyAtc = document.querySelector('.sticky-add-to-cart__btn');
      if (stickyAtc) stickyAtc.textContent = 'Notify Me';
      document.querySelectorAll('[data-add-to-cart-text]').forEach((atc) => {
        atc.textContent = "Sold Out - Notify Me When It's Available";
      });
    }

    function applyMattressInStockUi() {
      getMainMattressFormWrapper()?.classList.remove('variant--soldout');
      document.querySelector('.atc-button')?.classList.add('actived');
      document.querySelector('.notify-button')?.classList.remove('actived');
      const stickyAtc = document.querySelector('.sticky-add-to-cart__btn');
      if (stickyAtc) stickyAtc.textContent = 'Add To Cart';
      document.querySelectorAll('[data-add-to-cart-text]').forEach((atc) => {
        atc.textContent = 'Add to Cart';
      });
      toggleSoldOutMessage(false);
      const atcSubmit = document.querySelector('.product__submit__item.atc_button:not(.hidden) .product__submit__add');
      if (atcSubmit) atcSubmit.disabled = false;
    }

    let mulberryOpenToken = 0;

    // Upgrade Now product (the other mattress in Limited Time Offer) is sold out:
    // do not show that popup. Show Mulberry for the origin mattress instead.
    function hideUpsellAndShowOriginMulberry() {
      hideUpsellCta();
      openMulberryForCurrentMattress();
    }

    function openMulberryForCurrentMattress() {
      if (isMattressSoldOutUi()) return;
      if (!window.mulberry || !mulberry.core || !mulberry.modal) return;

      const variantId =
        document.querySelector('.product-submit-form input[name="id"][data-product-select]')?.value ||
        document.querySelector('.product-submit-form input[name="id"]')?.value ||
        document.querySelector('[data-selected-id]')?.getAttribute('data-selected-id') ||
        '';
      if (!variantId) return;

      const request = ++mulberryOpenToken;
      window.setTimeout(async () => {
        if (request !== mulberryOpenToken) return;
        if (isMattressSoldOutUi()) return;
        hideUpsellCta();

        try {
          const variantResponse = await fetch(`/variants/${encodeURIComponent(variantId)}.json`);
          if (!variantResponse.ok) return;
          const product = await variantResponse.json();
          if (request !== mulberryOpenToken || !product || !product.variant) return;

          const offers = await mulberry.core.getWarrantyOffer({
            id: variantId,
            title: product.product && product.product.title,
            price: product.variant.price,
            detail: product
          });
          if (request !== mulberryOpenToken || !offers) return;
          if (isMattressSoldOutUi()) return;

          window.pdpModal = await mulberry.modal.init({
            offers: offers,
            settings: mulberry.core.settings,
            onWarrantySelect: async (warranty) => {
              if (window.mulberryShop && typeof mulberryShop.addWarrantyToCart === 'function') {
                await mulberryShop.addWarrantyToCart(variantId, product, warranty);
              }
              try { mulberry.modal.close(); } catch (e) {}
            },
            onWarrantyDecline: async () => {
              try { mulberry.modal.close(); } catch (e) {}
            }
          });
          if (request !== mulberryOpenToken || isMattressSoldOutUi()) return;
          if (typeof window.pdpModal.open === 'function') window.pdpModal.open();
        } catch (err) {
          console.error('Unable to open Mulberry', err);
        }
      }, 0);
    }

    function showUpsellCta() {
      if (isMattressSoldOutUi()) {
        hideUpsellCta();
        return;
      }
      const originRow = document.querySelector('.product_add_to_cart-button .product__submit__item');
      const upsellVisible = Boolean(document.querySelector('.upsell-popup__button:not(.hidden)'));
      if (upsellVisible && originRow?.classList.contains('hidden')) {
        document.querySelector('.upgrade_widget')?.classList.remove('hidden');
        return;
      }
      document.querySelectorAll('.upsell-popup__button').forEach((button) => {
        button.classList.remove('hidden');
      });
      document.querySelector('.upgrade_widget')?.classList.remove('hidden');
      originRow?.classList.add('hidden');
      document.querySelector('.sticky-add-to-cart__btn')?.classList.add('hidden');
    }

    function findUpsellVariantForSize(upsellProduct, sizeLabel) {
      const variants = upsellProduct?.variants || [];
      if (!variants.length || !sizeLabel) return null;
      const size = String(sizeLabel).trim();
      const sizeLower = size.toLowerCase();
      // Exact matches only — do not use .includes() ("King" must not match "Cal King").
      return (
        variants.find((v) => String(v.title || '').trim().toLowerCase() === sizeLower) ||
        variants.find((v) => String(v.option1 || '').trim().toLowerCase() === sizeLower) ||
        variants.find((v) => {
          const title = String(v.title || '');
          return title === size || title.indexOf(size + ' /') === 0 || title.indexOf(size + '/') === 0;
        }) ||
        variants.find((v) => Array.isArray(v.options) && v.options.some((o) => String(o).trim().toLowerCase() === sizeLower)) ||
        null
      );
    }

    function isUpsellVariantPurchasable(variant) {
      if (!variant || !variant.id) return false;
      // Only trust explicit unavailability. Rebuy often omits/zeros inventory
      // fields even when Shopify will still accept the add.
      if (variant.available === false) return false;
      return true;
    }

    async function getUpsellProduct(variantID, sizeLabel) {
      // Mattress Limited Time Offer upsell popup disabled for this release.
      if (!document.querySelector('.upsell-popup__wrapper')) return;

      const requestToken = ++upsellRequestToken;
      sizeLabel = sizeLabel || getSelectedMattressSizeLabel();
      const originIdInput = document.querySelector('.upsell-popup__container .product__id');
      const addInput = document.querySelector('.upsell-popup__container [data-product-id]');
      const upsellIdInput = document.querySelector('.upsell-popup__container .upsell-product__id');

      if (!variantID || isMattressSoldOutUi()) {
        hideUpsellCta(false);
        return;
      }

      if (originIdInput) originIdInput.value = variantID;
      if (addInput) addInput.value = variantID;

      const dataId = document.querySelector('.upsell-popup__wrapper')?.dataset.upsellId;
      const shopifyProductId =
        document.querySelector('custom-product[data-product-id]')?.dataset.productId ||
        document.querySelector('[data-current-id]')?.getAttribute('data-current-id') ||
        '';
      if (!dataId) {
        hideUpsellCta(false);
        return;
      }

      let upsellProduct = [];
      try {
        const response = await fetch(
          `https://wapi.zinus.com/api/rebuy-proxy?data_id=${encodeURIComponent(dataId)}&product_ids=${encodeURIComponent(shopifyProductId)}&variant_ids=${encodeURIComponent(variantID)}`
        );
        const data = await response.json();
        upsellProduct = data?.data || [];
      } catch (err) {
        if (requestToken !== upsellRequestToken) return;
        console.error('Unable to load upsell product', err?.message);
        hideUpsellCta(false);
        return;
      }

      if (requestToken !== upsellRequestToken) return;

      const offer = upsellProduct[0];
      let matchedVariant = findUpsellVariantForSize(offer, sizeLabel);
      // Rebuy usually returns only the requested size. Use that variant if
      // title rematch misses ("Full" vs "Full / Hybrid", etc.).
      if (!matchedVariant && Array.isArray(offer?.variants) && offer.variants.length === 1) {
        matchedVariant = offer.variants[0];
      }

      // Sold-out / missing upgrade size: keep origin ATC, never submit a dead variant.
      if (!offer || !matchedVariant?.id || isMattressSoldOutUi()) {
        hideUpsellCta(false);
        return;
      }
      if (matchedVariant.available === false) {
        hideUpsellCta(false);
        return;
      }

      // Rebuy often omits `available`. Shopify is the source of truth.
      const offerHandle = offer.handle;
      if (offerHandle) {
        try {
          const liveRes = await fetch(`/products/${encodeURIComponent(offerHandle)}.js`);
          if (liveRes.ok) {
            const liveProduct = await liveRes.json();
            const liveVar = (liveProduct.variants || []).find((v) => String(v.id) === String(matchedVariant.id))
              || findUpsellVariantForSize(liveProduct, sizeLabel);
            if (liveVar && liveVar.available === false) {
              if (requestToken !== upsellRequestToken) return;
              hideUpsellCta(false);
              return;
            }
          }
        } catch (err) {}
      }

      if (requestToken !== upsellRequestToken || isMattressSoldOutUi()) return;

      cachedUpsellProduct = offer;
      showUpsellCta();
      if (requestToken !== upsellRequestToken) return;

      const salePrice = document.querySelector('.pdp-variant-1 .compare_at_price')?.textContent;
      const realPrice = document.querySelector('.upsell-product__info .real_price');
      if (realPrice) realPrice.textContent = salePrice || '+$0';

      if (addInput) addInput.value = variantID;
      if (upsellIdInput) upsellIdInput.value = matchedVariant.id;
      if (originIdInput) originIdInput.value = variantID;

      try {
      const parentElement = document.querySelector('.upsell-product__details');
      const childElement = document.querySelector('.upsell-product__details .upgrades');
      if (parentElement && childElement) {
        parentElement.removeChild(childElement);
      }

      const parentImgElement = document.querySelector('.upsell-popup__image');
      const childImgElement = document.querySelector('.upsell-popup__image img');
      if (parentImgElement && childImgElement) {
        parentImgElement.removeChild(childImgElement);
      }

      const metafields = offer.metafields || [];
      const mattressPropertyInfo = metafields.find((m) => m.key === 'upsell_product_property_info');
      const upsellMainImage = metafields.find((m) => m.key === 'upsell_product_main_image');
      const upsellPropertyImage = metafields.find((m) => m.key === 'upsell_product_property_image');
      const upsellBadge = metafields.find((m) => m.key === 'upsell_product_badge');
      const upsellBadgeBackground = metafields.find((m) => m.key === 'upsell_product_badge_bg_color');
      const upsellProductTitle = metafields.find((m) => m.key === 'upsell_product_title');
      const upsellProductHeading = metafields.find((m) => m.key === 'upsell_product_heading');

      document.querySelectorAll('.upsell-product__title').forEach((element) => {
        element.textContent = upsellProductTitle?.value || '';
      });

      const popupDescription = document.querySelector('.popup-description');
      if (popupDescription) popupDescription.textContent = upsellProductHeading?.value || '';

      const titleContainer = document.querySelector('.upsell-product__origin-title');
      if (titleContainer) {
        titleContainer.textContent = offer.title || '';

        const link = document.createElement('a');
        link.className = 'ab-variant-b';
        link.href = safeUrl(offer.link);
        link.textContent = 'View Product';
        titleContainer.append(' ');
        titleContainer.appendChild(link);
      }

      const upgradesContainer = document.createElement('div');
      upgradesContainer.classList.add('upgrades');

      const imageContainer = document.createElement('div');
      imageContainer.classList.add('upgrades-image');

      const img = document.createElement('img');
      img.classList.add('original_image');

      if (upsellPropertyImage?.value) {
        img.src = safeImageUrl(upsellPropertyImage.value);
        img.alt = offer.title || '';
      } else {
        img.src = safeImageUrl(offer?.image?.src);
        img.alt = offer?.image?.alt || '';
      }

      imageContainer.appendChild(img);

      if (upsellMainImage?.value) {
        const mainImage = document.createElement('img');
        mainImage.src = safeImageUrl(upsellMainImage.value);
        mainImage.alt = 'upsell product image';
        document.querySelector('.upsell-popup__image')?.appendChild(mainImage);
      }

      if (upsellBadge?.value) {
        const badge = document.querySelector('.upsell-product__badge');
        if (badge) {
          badge.textContent = upsellBadge.value || '';
          badge.style.background = safeColor(upsellBadgeBackground?.value);
        }
      }

      const textBox = document.createElement('div');
      textBox.classList.add('upgrades-textbox');

      let propertyInfoList = [];
      try {
        propertyInfoList = JSON.parse(mattressPropertyInfo?.value || '[]');
      } catch {
        propertyInfoList = [];
      }

      propertyInfoList.forEach((value) => {
        const textDiv = document.createElement('div');
        textDiv.classList.add('upgrades-text');

        const iconWrapper = document.createElement('span');
        iconWrapper.classList.add('upgrade-icon');
        iconWrapper.setAttribute('aria-hidden', 'true');
        iconWrapper.appendChild(createUpsellIcon());

        const textSpan = document.createElement('span');
        textSpan.textContent = value || '';

        textDiv.appendChild(iconWrapper);
        textDiv.appendChild(textSpan);
        textBox.appendChild(textDiv);
      });

      upgradesContainer.appendChild(imageContainer);
      upgradesContainer.appendChild(textBox);

      document.querySelector('.upsell-product__details')?.appendChild(upgradesContainer);
    } catch (err) {
      console.error('Unable to render upsell product', err?.message);
    }
    }

    document.querySelectorAll('.sticky-select-popout__item').forEach(item => {
      // Ensure keyboard accessibility if not a button
      if (!item.matches('button, a')) {
        item.setAttribute('role', 'option');
        item.setAttribute('tabindex', '0');
      }
    
      const activateItem = (e) => {
        e.preventDefault();
        e.stopPropagation();
    
        const optionEl = item.querySelector('.select-popout__option');
        const priceEl = item.querySelector('.option_price');
        if (!optionEl || !priceEl) return;
    
        const selectedItem = optionEl.dataset.value;
        const selectedPrice = priceEl.textContent.trim();

        // Hide/show protector block immediately for sticky size (Queen OOS → hidden).
        if (isMattressBedSizeLabel(selectedItem)) {
          syncMattressProtectorUpsell(selectedItem);
          if (item.classList.contains('sold-out')) hideUpsellCta();
          else upsellRequestToken += 1;
        }
    
        // Sync real select option safely
        const realOption = document.querySelector(
          `.select-popout__list__scroll .select-popout__option[data-value="${CSS.escape(selectedItem)}"]`
        );
    
        if (realOption) {
          setTimeout(() => {
            try {
              realOption.focus({ preventScroll: true });
            } catch (err) {}
            realOption.click();
          }, 1000);
        }
    
        // Update current state
        document.querySelectorAll('.sticky-select-popout__item')
          .forEach(el => el.classList.remove('select-popout__item--current'));
    
        item.classList.add('select-popout__item--current');
    
        const stickyPopout = document.querySelector('.sticky-atc .select-popout');
        if (stickyPopout) {
          stickyPopout.classList.toggle('sold-out', item.classList.contains('sold-out'));
        }
    
        const popout = item.closest('.select-popout');
        if (!popout) return;
    
        const toggle = popout.querySelector('.select-popout__toggle');
        const list = popout.querySelector('.zin-select-popout__list');
    
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
    
          const valueEl = toggle.querySelector('.select-popout__value');
          const priceValueEl = toggle.querySelector('.sticky-option_price');
    
          if (valueEl) valueEl.textContent = selectedItem;
          if (priceValueEl) priceValueEl.textContent = selectedPrice;
    
          toggle.focus(); // ADA: return focus to control
        }
    
        if (list) {
          list.classList.remove('select-popout__list--visible');
        }
      };
    
      // Mouse
      item.addEventListener('click', activateItem);
    
      // Keyboard
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          activateItem(e);
        }
      });
    });    

    document.querySelector('.sticky-add-to-cart__btn')?.addEventListener('click', function (e) {
      e.preventDefault();
      if (routeMattressCtaClick(e)) return;
      clickOriginMattressAtc();
    });
    
    document.querySelector('.sticky-custom_buy-now')?.addEventListener('click', function (e) {
      e.preventDefault();
    
      const targetBtn = document.querySelector('.custom-buy-button');
    
      if (!targetBtn) return;
    
      targetBtn.focus();
      targetBtn.click();
    });
    

    function rebuyOptionSelector(){
      document.querySelectorAll('.cross_product-item')?.forEach(item => {

        item.querySelectorAll('.select-popout__toggle').forEach(button => {
          button.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(button.closest('.select-popup__item').querySelector('.select-popout__list').classList.contains('select-popout__list--visible')){
              this.setAttribute('aria-expanded', 'false');
              button.closest('.select-popup__item').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
            }else{
              this.setAttribute('aria-expanded', 'true');
              button.closest('.select-popup__item').querySelector('.select-popout__list').classList.add('select-popout__list--visible');
            }
          })
        })

        item.querySelectorAll('.item_options .select-popup__item').forEach(itenOption => {
          itenOption?.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(popupItem => {
            popupItem?.addEventListener('click', function(e){
              e.preventDefault();
              e.stopPropagation();
              let selectedTitle = popupItem.querySelector('.select-popout__option').dataset.value;
              itenOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(item => {
                item.classList.remove('select-popout__item--current');
              })
              popupItem.classList.add('select-popout__item--current');
              let selectedId = popupItem.closest('.select-popout__item').getAttribute('id');
              popupItem.closest('.select-popup__item').querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', selectedId);
              popupItem.classList.add('select-popout__item--current');
              document.querySelectorAll('#select-Height-label .select-popout__item').forEach(element =>{
                element.setAttribute('aria-selected', false);
              })
              popupItem.setAttribute('aria-selected', true);
              popupItem.closest('.select-popup__item').querySelector('.select-popout__value').textContent = selectedTitle;
              popupItem.closest('.select-popup__item').querySelector('.select-popout__toggle').setAttribute('aria-expanded', 'false');
              popupItem.closest('.select-popup__item').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
              swatchVariants(item);
            })
          })
        })

        item.querySelectorAll('.item_options .swatch__button').forEach(option => {
          option?.querySelector('.swatch__input').addEventListener('click', function(){
            swatchVariants(item);
          })
        })
        
      })
    }

    function swatchVariants(item, filtertext=''){
      let colors = item.querySelectorAll('.item_options .swatch__button');
      let options = [];
      let productUrl = `https://zinus.com/products/${item.dataset.handle}.js`;
      let size = document.querySelector('.select-popout__list__scroll .select-popout__item--current span')?.textContent.trim();
      let height = item.querySelector('.select-popup__item .select-popout__item--current span')?.dataset.value;
      if(filtertext == 'popup'){
        document.querySelectorAll('.rebuy_popup-wrapper .radio__fieldset').forEach(item => {
          let value = item.querySelector('.variant_radio_input:checked').value;
          options.push(value);
        })
        options.push(size);
      }else{
        colors.forEach(selectedColor => {
          if(selectedColor.querySelector('input[type="radio"]:checked')){
            let color = selectedColor.querySelector('input[type="radio"]:checked').value;
            if (!color) return;
            item.querySelector('.selected_color-name').textContent = color;
            options.push(color);
          }
        })
        if(height){
          options.push(height);
        }
        if(size){
          options.push(size);
        }
      }

      fetch(productUrl)
          .then(response => {
              if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
          })
          .then(data => {
              let variantJson = data.variants;
              let currentVariant = variantJson.find((variant) => {
                return !variant.options.map((option, index) => {
                  return options[index] === option;
                }).includes(false);
              });
              if (!currentVariant){
                return;
              }
              let variantPrice = (currentVariant.price / 100).toFixed(2);
              let variantComparePrice = (currentVariant.compare_at_price / 100).toFixed(2);
              if(currentVariant.compare_at_price != null){
                item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden) .product__price--compare').textContent = '$'+variantComparePrice;
              }
              item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden)').dataset.variantId = currentVariant.id;
              item.querySelector('.title-with-price').querySelector('.price-wrapper:not(.hidden) .variant_price').textContent = '$'+variantPrice;
              item.closest(`[data-product-part]`).querySelector('.cross_product-details').dataset.variantSku = currentVariant.sku;
              item.closest(`[data-product-part]`).querySelector('[data-product-select]').value = currentVariant.id;
              item.closest(`[data-product-part]`).querySelector('[data-product-select]').dataset.productAvailable = currentVariant.available;
              item.querySelector('.cross_product-image img').src = safeImageUrl(currentVariant.featured_image.src || '');
              if(currentVariant.available){
                item.querySelector('.cross_product-checked').disabled = false;
                item.querySelector('.cross_product-checked .icon-plus').classList.remove('hidden');
                item.querySelector('.cross_product-checked .add_button').textContent = 'Add'
                item.querySelector('.cross_product-checked').classList.remove('button_clicked');
              }else{
                item.querySelector('.cross_product-checked').disabled = true;
                item.querySelector('.cross_product-checked .icon-plus').classList.add('hidden');
                item.querySelector('.cross_product-checked .add_button').textContent = 'Sold Out'
              }
            })
          .catch(error => {
              console.error(`There was a problem with the fetch operation: ${error?.message || 'Unknown error'}`);
      });
    }

    function popupVariantSwap (){
      document.querySelectorAll('.rebuy_popup-wrapper .cross_product-item')?.forEach(item => {
        item.querySelectorAll('.item_options .swatch__button').forEach(option => {
          option.querySelector('.swatch__input').addEventListener('click', function(){
            swatchVariants(item, 'popup');
          })
        })

        item.querySelectorAll('.item_options .radio__button').forEach(option => {
          option.querySelector('.radio__input').addEventListener('click', function(){
            swatchVariants(item, 'popup');
          })
        })
        
      })
    }

    function quickView() {
      const wrapper = document.querySelector('.cross_products-wrapper');
      if (!wrapper) return;

      let lastFocusedEl = null;

      function openModal() {
        openRebuyPopupModal(lastFocusedEl);
      }

      function closeModal() {
        closeRebuyPopupModal();
      }

      wrapper.addEventListener('click', function (e) {
        // Do not open quick view when interacting with swatches or add button
        const isSwatch = e.target.closest('.swatch__label, .swatch__input, .swatch__button');
        const isAddBtn = e.target.closest('.cross_product-checked');
        if (isSwatch || isAddBtn) return;

        const cardEl = e.target.closest('.cross_product-item');
        const partEl = e.target.closest('[data-product-part]');

        if (!cardEl || !partEl) return;

        let quickViewDescription = '';
        const productHandle = cardEl.dataset.handle;
        const selectedVariantId = partEl.querySelector('[data-product-select]')?.value;

        if (!productHandle || !selectedVariantId) return;

        const detailsEl = e.target.closest('.cross_product-details');
        const variantTitle = detailsEl?.querySelector('.product_title')?.textContent.trim() || '';
        const variantPrice = detailsEl?.querySelector('.variant-with-price .variant_price')?.dataset.price || '';
        const variantSku = detailsEl?.dataset.variantSku || '';
        const variantId = selectedVariantId;

        const container = enableMulberryUpsell ? '.popup-mulberry-inner' : null;
        const mulberryHiddenMarkup = enableMulberryUpsell
          ? '<div class="mulberry-id"></div><input type="hidden" class="mulberry-product-id" name="properties[mulberry]" value="">'
          : '';
        const quickViewMulberryMarkup = enableMulberryUpsell
          ? '<div class="popup-mulberry-inner"></div><button type="button" class="quick_purchase_button">I don&#39;t want to protect my purchase</button>'
          : '';

        const selectedColor = partEl.querySelector('.variant_radio_input:checked')?.value || '';
        const selectedSize = partEl.querySelector('.select-popout__value')?.textContent?.trim() || '';

        const quantityAvailable = partEl.querySelector('[data-product-select]')?.dataset.productAvailable;
        const isAvailable = quantityAvailable === 'true';

        const textButton = isAvailable ? 'Add' : 'Sold Out';
        const disabledButton = isAvailable ? '' : 'disabled';

        const getMetafieldsUrl = `https://zinus.com/products/${encodeURIComponent(productHandle)}?view=view`;

        // Keep focus context: the element that triggered opening
        lastFocusedEl = e.target.closest('.price-wrapper, button, a, [tabindex]') || e.target;

        fetch(getMetafieldsUrl)
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok: ' + response.statusText);
            return response.text();
          })
          .then((html) => {
            quickViewDescription = html || '';

            const productUrl = `https://zinus.com/products/${encodeURIComponent(productHandle)}.js`;
            const sizeValue =
              document.querySelector('.select-popout__list__scroll .select-popout__item--current span')
                ?.textContent.trim() || '';

            return fetch(productUrl)
              .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
                return response.json();
              })
              .then((item) => {
                const dialogTitleId = `rebuy-qv-title-${item.id}`;
                const dialogDescId = `rebuy-qv-desc-${item.id}`;

                const safeFeaturedImage = safeImageUrl(item.featured_image || '');
                const safeTitle = escapeHtml(item.title || '');
                const safeHandle = escapeHtml(item.handle || '');
                const safeSelectedVariantId = escapeHtml(selectedVariantId || '');
                const safeDialogTitleId = escapeHtml(dialogTitleId);
                const safeDialogDescId = escapeHtml(dialogDescId);
                const safeSizeValue = escapeHtml(sizeValue || '');
                const safeTextButton = escapeHtml(textButton);

                let productsBody = `
                  <div class="rebuy-quickview-modal"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="${safeDialogTitleId}"
                      aria-describedby="${safeDialogDescId}">
                    <button type="button" class="close_popup" aria-label="Close dialog">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192">
                        <path d="M150 42 42 150M150 150 42 42" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
                      </svg>
                    </button>

                    <p id="${safeDialogDescId}" class="visually-hidden">
                      Quick view. Press Escape to close. Tab moves between options.
                    </p>

                    <form method="post" action="/cart/add" class="product__form" enctype="multipart/form-data"
                          data-product-form data-product-part>
                      <input type="hidden" name="id" value="${safeSelectedVariantId}" data-product-select>
                      <input type="hidden" class="rebuy-attribution" name="properties[_attribution]" value="Rebuy Product">
                      <input type="hidden" class="rebuy-source" name="properties[_source]" value="Rebuy">
                      <input type="hidden" class="rebuy-widget-id" name="properties[_widget_id]" value="166634">
                      ${mulberryHiddenMarkup}

                      <div class="cross_product-item" data-product-id="${escapeHtml(item.id || '')}" data-handle="${safeHandle}">
                        <div class="rebuy-quick-view__body__inner">
                          <div class="cross_product-image">
                            <img src="${safeFeaturedImage}" alt="${safeTitle}">
                          </div>
                        </div>

                        <div class="cross_product-details">
                          <h2 class="product_title" id="${safeDialogTitleId}">${safeTitle}</h2>

                          <div class="item_options">
                            ${(item.options || []).map((option) => {
                              if (!option?.name) return '';

                              const optionName = option.name.trim();
                              const safeOptionName = escapeHtml(option.name);

                              // COLOR
                              if (optionName === 'Color') {
                                const legendId = `qv-color-${item.id}`;
                                const name = `Color--${item.id}`;
                                let out = `<fieldset class="radio__fieldset" aria-labelledby="${escapeHtml(legendId)}">
                                            <legend id="${escapeHtml(legendId)}">Color</legend>`;

                                for (const val of option.values || []) {
                                  const rawVal = String(val || '');
                                  const colorName = rawVal.toLowerCase();
                                  const rawHexValue = getColorValue(dataColors, colorName);
                                  const hexValue = safeColor(rawHexValue || '');
                                  const inputId = `qv-color-${item.id}-${rawVal.replace(/\s+/g, '-')}`;
                                  const checked = rawVal.trim() === selectedColor.trim() ? 'checked' : '';

                                  out += `
                                    <span class="swatch__button" data-tooltip="${escapeHtml(rawVal)}">
                                      <input type="radio"
                                            class="swatch__input variant_radio_input"
                                            data-single-option-selector
                                            data-index="option"
                                            name="${escapeHtml(name)}"
                                            value="${escapeHtml(rawVal)}"
                                            id="${escapeHtml(inputId)}"
                                            ${checked}>
                                      <label for="${escapeHtml(inputId)}"
                                            class="swatch__label"
                                            data-swatch="${escapeHtml(rawVal)}"
                                            title="${escapeHtml(rawVal)}"
                                            ${hexValue ? `style="background-color:${hexValue};"` : ''}>
                                        <span class="visually-hidden">${escapeHtml(rawVal)}</span>
                                      </label>
                                    </span>
                                  `;
                                }

                                out += `</fieldset>`;
                                return out;
                              }

                              // NOT SIZE => treat as radio group
                              if (optionName !== 'Size') {
                                const legendId = `qv-opt-${item.id}-${option.name.replace(/\s+/g, '-')}`;
                                const name = `${option.name}--${item.id}`;
                                let out = `<fieldset class="radio__fieldset" aria-labelledby="${escapeHtml(legendId)}">
                                            <legend id="${escapeHtml(legendId)}" class="radio__legend__label">${safeOptionName}</legend>`;

                                for (const val of option.values || []) {
                                  const rawVal = String(val || '');
                                  const inputId = `qv-${item.id}-${option.name}-${rawVal.replace(/\s+/g, '-')}`;
                                  const checked = rawVal.trim() === selectedSize.trim() ? 'checked' : '';

                                  out += `
                                    <span class="radio__button">
                                      <input type="radio"
                                            class="radio__input variant_radio_input"
                                            data-single-option-selector
                                            data-index="option"
                                            name="${escapeHtml(name)}"
                                            value="${escapeHtml(rawVal)}"
                                            id="${escapeHtml(inputId)}"
                                            ${checked}>
                                      <label for="${escapeHtml(inputId)}" class="radio__label">
                                        <span>${escapeHtml(rawVal)}</span>
                                      </label>
                                    </span>
                                  `;
                                }

                                out += `</fieldset>`;
                                return out;
                              }

                              return '';
                            }).join('')}
                          </div>

                          <div class="title-with-price">
                            ${(item.variants || []).map((card) => {
                              if (String(card.id) == String(selectedVariantId)) {
                                const hideCompare = (card.compare_at_price === card.price || !card.compare_at_price) ? 'hidden' : '';
                                const cardPrice = Number((card.price || 0) / 100).toFixed(2);
                                const compare = card.compare_at_price ? Number(card.compare_at_price / 100).toFixed(2) : '';

                                return `
                                  <div class="price-wrapper"
                                      data-variant-name="${escapeHtml(card.title || '')}"
                                      data-variant-id="${escapeHtml(card.id || '')}"
                                      data-inventory-quantity="${escapeHtml(card.inventory_quantity || '')}">
                                    <div class="variant-with-price">
                                      <span class="sizeValue">(${safeSizeValue})</span>
                                      <span class="variant_price" data-price="${escapeHtml(cardPrice)}">$${escapeHtml(cardPrice)}</span>
                                      <span class="product__price--compare ${hideCompare}">${compare ? `$${escapeHtml(compare)}` : ''}</span>
                                    </div>
                                  </div>
                                `;
                              }
                              return '';
                            }).join('')}

                            <button class="cross_product-checked"
                                    type="submit"
                                    name="add"
                                    data-add-to-cart
                                    ${disabledButton}
                                    aria-label="${escapeHtml(isAvailable ? `Add ${item.title} to cart` : `${item.title} is sold out`)}">
                              <span class="icon-plus" aria-hidden="true"></span>
                              <span class="add_button">${safeTextButton}</span>
                            </button>
                          </div>

                          ${quickViewMulberryMarkup}

                          <div class="product_description"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                `;

                const popupWrapper = document.querySelector('.rebuy_popup-wrapper');
                if (!popupWrapper) return;

                popupWrapper.innerHTML = productsBody;

                const plusIconContainer = popupWrapper.querySelector('.icon-plus');
                if (plusIconContainer) {
                  plusIconContainer.replaceChildren(createUpsellIcon());
                }

                const productDescriptionContainer = popupWrapper.querySelector('.product_description');
                setSanitizedHtml(productDescriptionContainer, quickViewDescription);

                // open modal + focus management
                openModal();

                popupVariantSwap();
                productPopupWidget();

                popupWrapper.querySelector('.close_popup')?.addEventListener('click', closeModal);

                if (enableMulberryUpsell) {
                  popupWrapper.querySelector('.quick_purchase_button')?.addEventListener('click', function () {
                    const mulberryId = popupWrapper.querySelector('.mulberry-id');
                    if (mulberryId) {
                      mulberryId.innerHTML = '';
                    }
                    popupWrapper.querySelector('.cross_product-checked')?.click();
                  });

                  initializeMulberry(variantTitle, variantPrice, variantSku, variantId, container);
                }
              });
          })
          .catch((error) => {
            console.error(`There was a problem with the fetch operation: ${error?.message || 'Unknown error'}`);
          });
      });
    }

    document.querySelector('.zin-select__fieldset .select-popout__item--current a')?.click();
    // Ensure Queen (etc.) OOS protector state is correct even if synthetic size click did not run.
    syncMattressProtectorUpsell();
    syncMattressSoldOutUiFromSelectedSize();

    document.querySelector('.product_add_to_cart-button .product__submit__add.atc-button')?.addEventListener('click', function(e) {
      routeMattressCtaClick(e);
    }, true);

    document.querySelector('.sticky-add-to-cart__btn')?.addEventListener('click', function(e) {
      routeMattressCtaClick(e);
    }, true);

    document.querySelector('.custom_add-button')?.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (routeMattressCtaClick(e)) return;
      clickOriginMattressAtc();
    }, true);

    window.onload = (event) => {
      let stickyATC = document.querySelector('.sticky-atc');
      if(!stickyATC) return;
      var formHeight = 0;
      var stickyHidesTitleMq = window.matchMedia('(max-width: 767px)');

      function placeTitleAndPrice(stick) {
        var titleEl = document.querySelector('.product__title-and-price');
        var formWrapper = document.querySelector('.form__wrapper');
        if (!titleEl || !formWrapper) return;

        // ≤767px sticky CSS sets .sticky-atc .product__title-and-price { display: none }.
        // Moving the block there hides the PDP H1. Leave it in the form on those widths.
        if (stick && !stickyHidesTitleMq.matches) {
          if (titleEl.parentElement !== stickyATC) {
            stickyATC.appendChild(titleEl);
          }
        } else if (!formWrapper.contains(titleEl)) {
          formWrapper.prepend(titleEl);
        }
      }

      function triggerStickyAtc() {
        var submitForm = document.querySelector('.product-submit-form');
        var header = document.getElementById('SiteHeader');
        if (!submitForm || !header) return;

        let fromBottom = submitForm.offsetTop + submitForm.offsetHeight
        var shouldStick = window.scrollY > fromBottom - 100;

        if(shouldStick) {
          if (!header.classList.contains('sticky-form')) {
            header.classList.add('sticky-form');
            document.querySelector('body').classList.add('sticky-add-to-cart');
          }
          placeTitleAndPrice(true);
          // Chat launcher visibility: CSS only (hide on mobile sticky). Do not set
          // inline display — it sticks after resize and hides Talk to AI on desktop/Mac.
        }
        if(!submitForm.querySelector('.product__form__wrapper')) {
          submitForm.style.minHeight = `${formHeight}px`;
        }
        else {
          formHeight = submitForm.querySelector('.product__form__wrapper').offsetHeight;
          submitForm.style.minHeight = 0;
        }
        if(!shouldStick && header.classList.contains('sticky-form')) {
          header.classList.remove('sticky-form');
          document.querySelector('body').classList.remove('sticky-add-to-cart');
          placeTitleAndPrice(false);
        }
      }
      var stickyScrollTicking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (stickyScrollTicking) return;
          stickyScrollTicking = true;
          requestAnimationFrame(function () {
            triggerStickyAtc();
            stickyScrollTicking = false;
          });
        },
        { passive: true }
      );
      window.addEventListener(
        'resize',
        function () {
          if (stickyScrollTicking) return;
          stickyScrollTicking = true;
          requestAnimationFrame(function () {
            triggerStickyAtc();
            stickyScrollTicking = false;
          });
        },
        { passive: true }
      );

      (function subscribeVoiceflowCloseSticky() {
        window.addEventListener('message', function (event) {
          if (typeof event.data !== 'string' || event.data.indexOf('"type":"voiceflow:close"') === -1) return;
          try {
            var data = JSON.parse(event.data);
            if (data.type === 'voiceflow:close') {
              triggerStickyAtc();
            }
          } catch (e) {}
        });
      })();

      triggerStickyAtc();
      document.querySelectorAll('.select-popout__item').forEach(item => {
        item?.addEventListener('click', function(){
          // Size options only (height/material also use .select-popout__item).
          // Clearing sold-out UI from a height click would re-enable Mulberry while size is OOS.
          const isSizeOption = Boolean(
            this.querySelector('.option_price') ||
            this.querySelector('.total_price') ||
            this.querySelector('.sticky-option_price') ||
            this.classList.contains('sticky-select-popout__item') ||
            this.hasAttribute('data-inventory-number')
          );
          if (!isSizeOption && !this.classList.contains('sold-out')) return;
          const sizeLabel = this.querySelector('.select-popout__option')?.dataset?.value || '';
          if (!isMattressBedSizeLabel(sizeLabel)) return;

          if (isMattressSizeUnavailable(sizeLabel)) {
            applyMattressSoldOutUi();
          } else {
            applyMattressInStockUi();
          }
        });
      });
      document.querySelector('.select-popout__list-close')?.addEventListener('click', function(){
        document.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
        document.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
      });
    };

    function initSwiper(){
      var galleryRoot = document.querySelector('.product-single__gallery .gallery-top');
      if (!galleryRoot) return;

      var slideCount = galleryRoot.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
      var useLoop = slideCount > 2;

      var galleryThumbs = new Swiper(`.product-single__gallery .gallery-thumbs`, {
        centeredSlides: false,
        spaceBetween: 10,
        slideToClickedSlide: true,
        slidesPerView: 5.5,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      var galleryTop = new Swiper(`.product-single__gallery  .gallery-top`, {
        loop: useLoop,
        loopedSlides: useLoop ? Math.min(slideCount, 3) : 0,
        spaceBetween: 10,
        navigation: {
          nextEl: `.product-single__gallery .swiper-button-next`,
          prevEl: `.product-single__gallery .swiper-button-prev`,
        },
        pagination: {
          el: ".product-single__gallery .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<li class="' + className + '" data-pagination-index="'+(index+1)+'"></li>';
          },
        },
        on: {
          init: function () {
            updateTabIndex();
            let el = document.querySelector('.gallery-top .swiper-wrapper');
            if (el) {
              setTimeout(() => {
                el.removeAttribute('aria-live');
              }, 1000);
            }
          },
          slideChangeTransitionEnd: function () {
            updateTabIndex();
          }
        }
      });

      window.__zinusGalleryTop = galleryTop;
      window.__zinusGalleryThumbs = galleryThumbs;

      document.addEventListener('zinus:gallery:hydrated', function () {
        try {
          if (window.__zinusGalleryTop) {
            window.__zinusGalleryTop.update();
            window.__zinusGalleryTop.slideTo(0, 0);
          }
          if (window.__zinusGalleryThumbs) {
            window.__zinusGalleryThumbs.update();
          }
        } catch (_) {}
      });

      function updateTabIndex() {
        document.querySelectorAll('.gallery-top .swiper-slide').forEach(slide => {
          let focusableElements = slide.querySelectorAll(
            'a[href], img, button, input, select, textarea, [tabindex]'
          );
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('tabindex', '0');
            slide.setAttribute('aria-hidden', 'false');
            // Add tabindex="-1" to each
            focusableElements.forEach(el => {
              el.removeAttribute('tabindex');
            });
          } else {
            slide.setAttribute('tabindex', '-1');
            slide.setAttribute('aria-hidden', 'true');
            // Add tabindex="-1" to each
            focusableElements.forEach(el => {
              el.setAttribute('tabindex', '-1');
            });
          }
        });
      }

      setTimeout(() => {
        let swiperWrapper = document.querySelector('.product-single__gallery .gallery-thumbs .swiper-wrapper');

        // Check if it exists and has the aria-live attribute, then remove it
        if (swiperWrapper && swiperWrapper.hasAttribute('aria-live')) {
          swiperWrapper.removeAttribute('aria-live');
        }
        swiperWrapper.querySelectorAll('.swiper-slide').forEach(item => {
          item.removeAttribute('role');
          item.removeAttribute('aria-label');
        })
      }, 1000);

      document.querySelector('.product-single__gallery .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slider => {
        slider.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          let index = this.querySelector('.product-single__thumbnail').dataset.number;
          document.querySelector('.product-single__gallery').querySelector(`[data-pagination-index="`+index+`"`).click();
          document.querySelector('.product-single__gallery .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slide => {
            slide.querySelector('.product-single__thumbnail-link').removeAttribute('aria-current');
          })
          this.querySelector('.product-single__thumbnail-link').setAttribute('aria-current', true);
        })
        slider.querySelector('.product-single__thumbnail-link')?.addEventListener('keydown', (e) =>{
          if(e.code == 'Space' || e.key == 'Enter'){
            e.preventDefault();
            e.stopPropagation();
            slider.click();
          }
        })
      })
    }

    

    function getUpgradeTitleTokens(radioValue) {
      if (!radioValue) return [];

      let normalized = String(radioValue);
      if (normalized.includes('Ultra Cooling')) {
        normalized = normalized.replace('Ultra Cooling', 'Ultra-Cool');
      }

      // Keep legacy Original/Cooling/Ultra matching unchanged on classic mattress PDPs.
      // Only map to Core/Signature/Luxe on Balanced Comfort.
      if (!isBalancedComfortProduct()) {
        return [normalized];
      }

      const aliasMap = {
        Original: ['Original', 'Core'],
        Core: ['Core', 'Original'],
        Cooling: ['Cooling', 'Signature'],
        Signature: ['Signature', 'Cooling'],
        'Ultra-Cool': ['Ultra-Cool', 'Ultra Cooling', 'Luxe'],
        'Ultra Cooling': ['Ultra-Cool', 'Ultra Cooling', 'Luxe'],
        Luxe: ['Luxe', 'Ultra-Cool', 'Ultra Cooling']
      };

      return aliasMap[normalized] || aliasMap[radioValue] || [normalized];
    }

    function upgradeTierMatches(title, radioValue) {
      const t = String(title || '').toLowerCase();
      const radio = String(radioValue || '').toLowerCase();
      const isUltra = /ultra|luxe/.test(radio);
      const isCooling = !isUltra && /cooling|signature/.test(radio);
      if (isUltra) return /ultra|luxe/.test(t);
      if (isCooling) return (/cooling|signature/.test(t) && !/ultra|luxe/.test(t));
      return (/original|core/.test(t) && !/cooling|signature|ultra|luxe/.test(t));
    }

    function upgradeMaterialMatches(title, materialValue) {
      const t = String(title || '').toLowerCase();
      const material = String(materialValue || '').toLowerCase();
      if (material.includes('hybrid')) return t.includes('hybrid');
      return t.includes('memory foam') || (t.includes('foam') && !t.includes('hybrid'));
    }

    function upgradeLookupKey(radioValue, materialValue) {
      const radio = String(radioValue || '').toLowerCase();
      let tier = 'original';
      if (/ultra|luxe/.test(radio)) tier = 'ultra cooling';
      else if (/cooling|signature/.test(radio)) tier = 'cooling';
      const material = String(materialValue || '').toLowerCase().includes('hybrid') ? 'hybrid' : 'memory foam';
      return tier + '|' + material;
    }

    function resolveUpgradeFallbackUrl(radioValue, materialValue) {
      if (isBalancedComfortProduct()) return '';
      const handle = LEGACY_UPGRADE_HANDLES[upgradeLookupKey(radioValue, materialValue)];
      if (!handle) return '';
      const currentHandle = document.querySelector('[data-product-handle]')?.dataset.productHandle || '';
      if (handle === currentHandle) return '';
      return '/products/' + handle;
    }

    function resolveUpgradeProductUrl(radioValue, materialValue) {
      if (!radioValue || !materialValue) return '';

      const currentProductId = document.querySelector('[data-current-id]')?.getAttribute('data-current-id');
      const currentHandle = document.querySelector('[data-product-handle]')?.dataset.productHandle || '';
      const sizeOption = getVisibleSelectedMattressSize();
      let productUrl = '';
      let matchedCurrent = false;
      let matchedUnpublished = false;

      document.querySelectorAll('.zinus_product').forEach((zinusProduct) => {
        if (productUrl || matchedCurrent) return;

        const productTitle = zinusProduct.dataset.productTitle || '';
        const relatedHandle = zinusProduct.dataset.productHandle || '';
        const isBalancedRelated = /balanced comfort|balanced-comfort/i.test(`${productTitle} ${relatedHandle}`);
        if (isBalancedComfortProduct() ? !isBalancedRelated : isBalancedRelated) {
          return;
        }
        if (!upgradeTierMatches(productTitle, radioValue) || !upgradeMaterialMatches(productTitle, materialValue)) {
          return;
        }

        const relatedUrl = zinusProduct.dataset.productUrl || '';
        const isCurrent =
          (currentProductId && String(zinusProduct.dataset.productId) === String(currentProductId)) ||
          (relatedHandle && relatedHandle === currentHandle);
        if (isCurrent) {
          matchedCurrent = true;
          return;
        }

        if (zinusProduct.dataset.published === 'false') {
          matchedUnpublished = true;
          return;
        }

        if (!relatedUrl || relatedUrl === '#' || relatedUrl.includes('/products/undefined')) return;

        const variantJson = zinusProduct.querySelector('[type="application/json"]')?.textContent;
        let variants = [];
        if (variantJson) {
          try {
            variants = JSON.parse(variantJson);
          } catch (e) {
            variants = [];
          }
        }

        const currentVariant =
          (sizeOption && Array.isArray(variants) && variants.find((variant) => sizeOption === variant.title))
          || (Array.isArray(variants) && variants.find((variant) => variant.available))
          || (Array.isArray(variants) && variants[0])
          || null;

        productUrl = currentVariant?.id
          ? `${relatedUrl}?variant=${currentVariant.id}`
          : relatedUrl;
      });

      if (productUrl || matchedCurrent) return productUrl;
      if (matchedUnpublished) return '';
      return resolveUpgradeFallbackUrl(radioValue, materialValue);
    }

    function getCurrentMattressIdentity() {
      const titleEl = document.querySelector('.mattress-product-title');
      const tag = titleEl?.value || titleEl?.textContent || '';
      const handle = document.querySelector('[data-product-handle]')?.dataset.productHandle || '';
      const currentProductId = document.querySelector('[data-current-id]')?.getAttribute('data-current-id');
      const relatedTitle = currentProductId
        ? document.querySelector(`.zinus_product[data-product-id="${currentProductId}"]`)?.dataset.productTitle || ''
        : '';
      return `${tag} ${handle} ${relatedTitle}`.toLowerCase();
    }

    function isCurrentUpgradeCombo(radioValue, materialValue) {
      const identity = getCurrentMattressIdentity();
      return upgradeTierMatches(identity, radioValue) && upgradeMaterialMatches(identity, materialValue);
    }

    function getSelectedUpgradeValue() {
      const checked = document.querySelector('.zin-radio__button .variant_radio_input:checked')?.dataset.value;
      if (checked) return checked;
      const identity = getCurrentMattressIdentity();
      if (/ultra-hybrid|ultra-green-tea|ultra cooling|luxe/.test(identity)) {
        return document.querySelector('#zinusPremierRadio--3 input')?.dataset.value || 'Ultra Cooling';
      }
      if (/cooling-hybrid|cooling-green-tea/.test(identity) || (/cooling|signature/.test(identity) && !/ultra|luxe/.test(identity))) {
        return document.querySelector('#zinusPremierRadio--2 input')?.dataset.value || 'Cooling';
      }
      return document.querySelector('#zinusOriginalRadio input')?.dataset.value || 'Original';
    }

    function getSelectedMaterialValue() {
      const checked = document.querySelector('.zin-material-radio .zin-radio__input:checked')?.dataset.value;
      if (checked) return checked;
      return /hybrid/.test(getCurrentMattressIdentity()) ? 'Hybrid' : 'Memory Foam';
    }

    function clearUnpublishedComboState() {
      unpublishedComboSelected = false;
      unpublishedComboSuccessorHandle = '';
    }

    function applyUnpublishedComboSoldOutUi(radioValue, materialValue) {
      unpublishedComboSelected = true;
      unpublishedComboSuccessorHandle =
        UNPUBLISHED_COMBO_SUCCESSOR_HANDLES[upgradeLookupKey(radioValue, materialValue)] || '';
      applyMattressSoldOutUi();
    }

    function handleMattressComboSelection(radioValue, materialValue) {
      radioValue = radioValue || getSelectedUpgradeValue();
      materialValue = materialValue || getSelectedMaterialValue();
      if (!radioValue || !materialValue) return;

      if (isBalancedComfortProduct()) {
        const productUrl = resolveUpgradeProductUrl(radioValue, materialValue);
        if (productUrl) window.location.href = productUrl;
        return;
      }

      if (isCurrentUpgradeCombo(radioValue, materialValue)) {
        clearUnpublishedComboState();
        syncMattressSoldOutUiFromSelectedSize();
        return;
      }

      const productUrl = resolveUpgradeProductUrl(radioValue, materialValue);
      if (productUrl) {
        window.location.href = productUrl;
        return;
      }

      applyUnpublishedComboSoldOutUi(radioValue, materialValue);
    }

    function swapProduct(){
      if (window.__zinusSwapProductBound) return;
      window.__zinusSwapProductBound = true;
      document.querySelectorAll('.swap-product__button').forEach(radioButton => {
        radioButton?.addEventListener('change', function(){
          document.querySelectorAll('.swap-product__button').forEach(button => {
            button.querySelector('.compare_at_price')?.classList.add('hidden');
          })
          const radioValue = document.querySelector('.zin-radio__button .variant_radio_input:checked')?.dataset.value
            || getSelectedUpgradeValue();
          const materialValue = document.querySelector('.zin-material-radio .zin-radio__input:checked')?.dataset.value
            || getSelectedMaterialValue();
          handleMattressComboSelection(radioValue, materialValue);
        })
      })
    }

    function mobileSwapProduct(){
      if (window.__zinusMobileSwapProductBound) return;
      window.__zinusMobileSwapProductBound = true;
      const items = document.querySelectorAll('.custom-select-popout__list__scroll .custom-select-popout__item');
      if (!items.length) return;

      items.forEach(listItem => {
        listItem?.addEventListener('click', function(){
          const materialValue = this.dataset.materialValue;
          if (!materialValue) return;
          const radioValue = document.querySelector('.zin-radio__button .variant_radio_input:checked')?.dataset.value
            || getSelectedUpgradeValue();
          listItem.closest('#material-listbox')?.classList.remove('custom-select-popout__list--visible');
          listItem.closest('#material-listbox')?.querySelectorAll('.custom-select-popout__item').forEach((item) => {
            item.classList.toggle('select-popout__item--current', item === listItem);
          });
          const valueEl = document.querySelector('.material_choose-wrapper .select-popout__value');
          if (valueEl) valueEl.textContent = materialValue;
          if (materialValue.toLowerCase().includes('hybrid')) {
            const hybridInput = document.querySelector('#materialHybrid input');
            if (hybridInput) hybridInput.checked = true;
          } else {
            const foamInput = document.querySelector('#materialMemoryFoam input');
            if (foamInput) foamInput.checked = true;
          }
          handleMattressComboSelection(radioValue, materialValue);
        })
      })
    }

    if(document.querySelector('.cross_widget')){
      document.querySelector('.cross_widget #cross_widget')?.addEventListener('change', function(){
        const widget = document.querySelector('.cross_widget');
        const variantId = document.querySelector('.cross_widget .product_title')?.dataset.productId || '';
        const checked = document.querySelector('.cross_widget #cross_widget')?.checked;
        document.querySelectorAll('.cross_widget .custom_checkbox').forEach((el) => {
          el.setAttribute('aria-checked', checked ? 'true' : 'false');
        });
        // Never write a protector id while hidden / OOS / empty.
        if (checked && variantId && widget && !widget.classList.contains('hidden')) {
          writeCrossWidgetFormInputs(variantId);
        } else {
          clearCrossWidgetFormInputs();
        }
      })
    }

    /* Custom Buy Now Button Function */

    if(document.querySelector('.custom-buy-button')){
      document.querySelector('.custom-buy-button').addEventListener('click', async function(event){
        event.preventDefault(); // Prevent form submission
        let selectedId = document.querySelector('[data-selected-id]')?.dataset.selectedId;
        addToCart('', selectedId);
      })
    }

    function addToCart(mulberryId, variantId){
      let formData = [];
      if(mulberryId){
        formData = {
          'items': [
            {
            'id': variantId,
            'quantity': 1
            },
            {
              'id': mulberryId,
              'quantity': 1
            }
          ]
        }
      }else{
        formData = {
          'items': [
            {
            'id': variantId,
            'quantity': 1
            }
          ]
        }
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(function(json) {
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error(`Error: ${error?.message || 'Unknown error'}`);
      });
    }

    function openUpsellModal(triggerEl) {
      if (!upsellModal) return;

      if (isMattressSoldOutUi()) {
        applyMattressSoldOutUi();
        return;
      }

      // Visible Limited Time Offer button must open that popup, not Mulberry.
      if (typeof window.__zinusCloseMulberryForUpsell === 'function') {
        window.__zinusCloseMulberryForUpsell();
      }

      upsellModalTrigger = triggerEl || document.activeElement;
      upsellModal.classList.remove('hidden');
      upsellModal.setAttribute('aria-hidden', 'false');

      const chatIcon = document.querySelector('#voiceflow-chat');
      if (chatIcon) chatIcon.style.zIndex = '999';

      trapFocusInModal(upsellModal);
      enableEscapeToClose(upsellModal, upsellCancelBtn);

      requestAnimationFrame(() => {
        upsellCancelBtn?.focus();
      });
    }

    function closeUpsellModal() {
      if (!upsellModal) return;

      upsellModal.classList.add('hidden');
      upsellModal.setAttribute('aria-hidden', 'true');

      const chatIcon = document.querySelector('#voiceflow-chat');
      if (chatIcon) chatIcon.style.zIndex = '21474';

      if (document.querySelector('.upgrade_widget input')) {
        document.querySelector('.upgrade_widget input').checked = false;
      }

      if (upsellModalTrigger && typeof upsellModalTrigger.focus === 'function') {
        upsellModalTrigger.focus();
      }
      upsellModalTrigger = null;
    }

    upsellModalBtn?.forEach(button => {
      button?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const openIfStillValid = () => {
          if (isMattressSoldOutUi()) {
            applyMattressSoldOutUi();
            return;
          }
          if (!getVisibleUpsellCta()) return;
          openUpsellModal(button);
        };
        if (pendingUpsellPromise) {
          pendingUpsellPromise.then(openIfStillValid);
          return;
        }
        openIfStillValid();
      })
    })

    upsellCancelBtn?.addEventListener('click', closeUpsellModal)

    if(document.querySelector('.upgrade_button')){
      document.querySelector('.upgrade_button').addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if (isMattressSoldOutUi()) {
          applyMattressSoldOutUi();
          return;
        }

        const sizeLabel = getSelectedMattressSizeLabel();
        const storedId = document.querySelector('.upsell-popup__container .upsell-product__id')?.value;
        let matched = findUpsellVariantForSize(cachedUpsellProduct, sizeLabel);
        if (!matched && storedId && cachedUpsellProduct && Array.isArray(cachedUpsellProduct.variants)) {
          matched = cachedUpsellProduct.variants.find((v) => String(v.id) === String(storedId)) || null;
        }
        if (!matched && storedId) matched = { id: storedId };
        if (matched && matched.available === false) {
          hideUpsellAndShowOriginMulberry();
          return;
        }
        if (!isUpsellVariantPurchasable(matched)) return;

        const addInput = document.querySelector('.upsell-popup__container [data-product-id]');
        const addBtn = document.querySelector('.upsell-popup__container [data-add-to-cart]');
        const originProductId = document.querySelector('.upsell-popup__container .product__id')?.value;
        if (!addInput || !addBtn) return;

        addInput.value = String(matched.id);
        addBtn.click();
        if (originProductId) addInput.value = originProductId;
      })
    }

    if(document.querySelector('.upgrade_widget')) {
      document.querySelector('.upgrade_widget input').addEventListener('change', function(){
        let input = document.querySelector('.upgrade_widget input');
        if(input && input.checked){
          openUpsellModal(input);
        }
      })
    }

    document.querySelector('.upsell-popup__container [data-add-to-cart]')?.addEventListener('click', function(e) {
      if (!isMattressSoldOutUi()) return;
      e.preventDefault();
      e.stopPropagation();
      applyMattressSoldOutUi();
    }, true);
      
  });